import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import { Table as AttdTable } from "ant-table-extensions";
import { Table, Dropdown, Menu } from "antd";
import Grid from "@mui/system/Unstable_Grid/Grid";
import refreshBtn from "../../assets/images/refresh_btn.png";
import Select from "react-select";
import axios from "axios";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import { Modal } from "react-bootstrap";
import { CSVLink, CSVDownload } from "react-csv";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useNavigate } from "react-router-dom";
import Index from "../Quickfilter/index";
import { Icon } from "@iconify/react";
import "./style.css";
import {
  TextField,
  Box,
  Grid as MuiGrid,
  Button,
  IconButton,
  Typography,
  useMediaQuery,
  Skeleton,
} from "@mui/material";
import Swal from "sweetalert2";
import SoftSnackbar from "components/SoftSnackbar";
import styled from "@emotion/styled";
import imga1 from "../../assets/images/imga1.png";
import imga2 from "../../assets/images/imga2.png";
import imga3 from "../../assets/images/imga3.png";
import imga4 from "../../assets/images/imga4.png";
import imga5 from "../../assets/images/imga5.png";
import imga6 from "../../assets/images/peoples.png";
import AddIcon from "@mui/icons-material/Add";
import noDataImg from "../../../src/assets/images/browser.png";
import upload from "../../assets/images/Upload_icon.png";
import info from "../../assets/images/Group 1000004191.png";
import SideDrawer from "./SideDrawer";

import {
  SBox1,
  SBox2,
  SBox3,
  SBox4,
  SBox5,
  SGHeading,
  SGSubHeading,
  SGTitles,
  SGToggles,
  SGraphSubHeading,
  SGridBox,
  SHeading,
  SHeading1,
  SKPICount,
  SKPIHeading,
  SKPISubHeading1,
  SKPISubHeading2,
  SUnderlineBox,
  SVerticalBox,
} from "./Style";
import A1 from "../../assets/images/KPI/1.png";
import A2 from "../../assets/images/KPI/2.png";
import A3 from "../../assets/images/KPI/3.png";
import A4 from "../../assets/images/KPI/4.png";
import A5 from "../../assets/images/KPI/5.png";
import A6 from "../../assets/images/KPI/6.png";
import A7 from "../../assets/images/KPI/7.png";
import { display, width } from "@mui/system";
import { render } from "@testing-library/react";

const copy = require("clipboard-copy");

export const colGuidelines = [
  {
    title: "Column Name",
    dataIndex: "col_name",
    width: 200,
  },
  {
    title: "Sample Entry",
    dataIndex: "sample",
    width: 200,
  },
  {
    title: "Guide",
    // dataIndex: "guide",
    width: 300,
    render: (text) => (
      <>
        {text.guide === " - " ? (
          <p style={{ display: "flex", justifyContent: "center" }}>{text.guide}</p>
        ) : (
          <p style={{ display: "flex", justifyContent: "center" }}>{text.guide}</p>
        )}
      </>
    ),
  },
  {
    title: "Link",
    // dataIndex: "link",
    width: 500,
    render: (text) => (
      <>
        {text.link === " - " ? (
          <p style={{ display: "flex", justifyContent: "center" }}>{text.link}</p>
        ) : (
          <a href={text.link}>{text.link}</a>
        )}
      </>
    ),
    // render: (text) => {
    //   <>{text.link !== " - " ? <a href={text.link}>{text.link}</a> : " - "}</>;
    // },
  },
];

export const GuideData = [
  {
    col_name: "Mobile Number",
    sample: "9859859855",
    guide:
      "Please set the column cell for mobile number as Text format. Click on the link to know how to do this setting",
    link: "https://support.microsoft.com/en-us/office/format-numbers-as-text-583160db-936b-4e52-bdff-6f1863518ba4",
  },
  {
    col_name: "Date of birth",
    sample: "11-05-1996",
    guide:
      "Please set the column cell for date of birth in DD-MM-YYYY format . Click on the link to know how to do this setting",
    link: "https://support.microsoft.com/en-us/office/format-a-date-the-way-you-want-8e10019e-d5d8-47a1-ba95-db95123d273e",
  },
  {
    col_name: "First Name",
    sample: "Ramesh",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Last Name",
    sample: "Pawar",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Email",
    sample: "ramesh@gmail.com",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Gender",
    sample: "Male",
    guide: "Please enter from options (Male,Female,Others)",
    link: " - ",
  },
  {
    col_name: "State",
    sample: "Maharashtra",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "District",
    sample: "Mumbai",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Taluka",
    sample: "Andheri",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Current Salary",
    sample: "10000-15000",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Desired Salary",
    sample: "15000-20000",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Experience",
    sample: "0-1",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Job Role",
    sample: "Waiter",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Industry",
    sample: "Hospitality and Management",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Language",
    sample: "Hindi",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Degree",
    sample: "Bachelors of Ed",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Highest Education",
    sample: "HSC",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Stream",
    sample: "Commerce",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Skills",
    sample: "Communications",
    guide: " - ",
    link: " - ",
  },
  {
    col_name: "Resume Link",
    sample: "Enter link of resume",
    guide: " - ",
    link: " - ",
  },
  // {
  //   col_name: "Language",
  //   sample: "Hindi",
  //   guide: " - ",
  //   link: " - ",
  // },
];

const StudentList = () => {
  // var fileSaver = require("file-saver");
  const matchsm = useMediaQuery("(max-width:768.5px)");
  const hiddenFileInput = useRef(null);
  const [copiedLink, setCopiedLink] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const cpId = sessionStorage.getItem("register_id");
  const [name, setName] = useState("");
  const [resumeModal, setResumeModal] = useState(false);
  const [resumefile, setResumeFile] = useState("");
  const [rowData, setRowData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [orgList, setOrgList] = useState([]);
  const [orgId, setOrgId] = useState(searchParams.get("orgid"));
  const [courseId, setCourseId] = useState(searchParams.get("courseid"));
  const [batchId, setBatchId] = useState(searchParams.get("batchid"));
  const [table1, setTable1] = useState([]);
  const [table2, setTable2] = useState([]);
  const [jobList, setJobList] = useState([]);
  const [batchList, setBatchList] = useState([]);
  const [uploadModal, setUploadModal] = useState(false);
  const [uploadedOption, setUploadOption] = useState(false);
  const [instructionModal, setInstructionModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [CSVFile, setCSVFile] = useState("");
  const [canId, setCanId] = useState("");
  const [time, setTime] = useState([]);
  const [candData, setCandData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [timelineLoading, setTimeLineLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [filteroff, setFilteroff] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [statefilter, setStatefilter] = useState("");
  const [districtfilter, setDistrictfilter] = useState("");
  const [datefilter, setDatefilter] = useState([]);
  const [jffilter, setJffilter] = useState("");
  const [educationfilter, setEducationfilter] = useState("");
  const [rolefilter, setRolefilter] = useState("");
  const [degreefilter, setDegreefilter] = useState("");
  const [boardingfilter, setBoardingfilter] = useState([18, 45]);
  const [table, setTable] = useState(0);
  const [tableshow, setTableshow] = useState(searchParams.get("show") === "onboarded" ? 2 : 0);
  const [allData, setAllData] = useState(true);
  const [stageSelect, setStageSelect] = useState({});
  const [veridetails, setVeridetails] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    date_of_birth: "",
    highest_education: "",
    current_salary: "",
    experience: "",
    job_role: "",
    dataSource: "",
    state: "",
    skills: "",
    taluka: "",
    district: "",
    lastactive: "",
    modified: "",
    registration_id: "",
    stream: "",
    current_industry: "",
    desired_salary: "",
    languages: "",
    self_opportunity: "",
    avl_skill: "",
    gender: "",
    marital_status: "",
    mobnum: "",
    address: "",
    wa_optin: "",
    resume: "",
    pincode: "",
    datasource: "",
    createddt: "",
  });
  var fileSaver = require("file-saver");
  const [KPIObj, setKPIObj] = useState({
    candidate_upload_count: "0",
    job_accepted_count: "0",
    job_assigned_count: "0",
    pipeline_count: "0",
    placed_count: "0",
    expectedCost: "0",
    actualCost: "0",
    formLink: "",
    qrLink: "",
  });
  console.log(batchId);
  const [kpiArr, setKpiArr] = useState([
    {
      heading: "Total Shortlisted",
      subheading: "Total Engaged : ",
      count1: 0,
      count2: 0,
      img: A1,
    },
    {
      heading: "Total Attending",
      subheading: "Total Completed : ",
      count1: 0,
      count2: 0,
      img: A2,
    },
    {
      heading: "Total OJT",
      subheading: "Total Passed : ",
      count1: 0,
      count2: 0,
      img: A3,
    },
    {
      heading: "Total Placed",
      subheading: "Total Verified : ",
      count1: 0,
      count2: 0,
      img: A4,
    },
    // {
    //   heading: "Total Job Fair",
    //   subheading: "Upcoming Job Fair : ",
    //   count1: 0,
    //   count2: 0,
    //   img: A5,
    // },
    // {
    //   heading: "Total Counsellor",
    //   subheading: "Recently Added : ",
    //   count1: 0,
    //   count2: 0,
    //   img: A6,
    // },
  ]);
  {
    /* New Modal States */
  }
  const [viewAttd, setViewAttd] = useState(false);
  const [batchDetail, setBatchDetail] = useState({});
  const [uploadMedia, setUploadMedia] = useState(false);
  const [refFile2, setRefFile2] = useState("");
  const [CSVFile2, setCSVFile2] = useState("");
  const [attdTable, setAttdTable] = useState([
    { date: "15-06-2024", clock_in: "09:30", clock_out: "18:30" },
    { date: "15-06-2024", clock_in: "09:30", clock_out: "18:30" },
    { date: "15-06-2024", clock_in: "09:30", clock_out: "18:30" },
    { date: "15-06-2024", clock_in: "09:30", clock_out: "18:30" },
  ]);
  const [viewDocsModal, setViewDocsModal] = useState(false);
  const [allDocs, setAllDocs] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusType, setStatusType] = useState(0);
  const [refFile1, setRefFile1] = useState("");
  const [CSVFile1, setCSVFile1] = useState("");
  const [stageName, setStageName] = useState("");
  const attendenceStatus = [
    { label: "Regular", value: "Regular" },
    { label: "Irregular", value: "Irregular" },
  ];
  const testStatus = [
    { label: "Done", value: "Done" },
    { label: "Passed", value: "Passed" },
    { label: "Failed", value: "Failed" },
    { label: "Not Attended", value: "Not Attended" },
  ];
  const ojtStatus = [
    { label: "Done", value: "Done" },
    { label: "Not Done", value: "Not Done" },
  ];
  const placementStatus = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];
  const selfEmpStatus = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];
  const handleClickFile = (event) => {
    hiddenFileInput.current.click();
  };
  console.log("params", tableshow, orgId, courseId);
  {
    /* New Modal States*/
  }
  const toggleSnackbar = () => setShowSnackbar(!showSnackbar);

  const ST1 = styled(Typography)({
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#6C6C6C",
  });

  const ST2 = styled(Typography)({
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#FF8000",
  });

  const ST3 = styled(Typography)({
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#3B5092",
  });

  const ST4 = styled(Typography)({
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "26px",
    fontFamily: "Poppins",
    color: "#000000",
  });

  const stylesDD = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      // borderColor: state.isFocused ? "grey" : "red",
      fontSize: "14px",
      fontFamily: "Poppins",
      width: "250px",
    }),
    option: (base) => ({
      ...base,
      // border: `1px dotted red`,
      height: "100%",
      fontSize: "14px",
      fontFamily: "Poppins",
    }),
  };

  const HandleTimeline = () => {
    setTimeLineLoading(true);
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/counsellor/associate/fetch/timeline`, {
        params: {
          candidate_id: candData?.registration_id,
          orgid: orgId,
          jobid: courseId,
        },
      })
      .then((res) => {
        setTimeLineLoading(false);
        setTime(res?.data?.timeline_details);
      })
      .catch((err) => {
        console.log(err);
        setTimeLineLoading(false);
      });
  };

  useEffect(() => {
    HandleTimeline();
  }, [candData]);

  const HandleFetchCandDetails = async (value) => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/register/jobseeker/register`, {
        params: { reg_id: value },
      })
      .then((res) => {
        setCandData(res.data.JobSeeker_List);
        setOpenModal(true);
        setVeridetails({
          first_name: res.data.JobSeeker_List.first_name,
          last_name: res.data.JobSeeker_List.last_name,
          email: res.data.JobSeeker_List.email,
          mobile: res.data.JobSeeker_List.mobile,
          date_of_birth:
            res.data.JobSeeker_List.date_of_birth !== null
              ? moment(res.data.JobSeeker_List.date_of_birth).format("YYYY-MM-DD")
              : null,
          highest_education: res.data.JobSeeker_List.highest_education,
          current_salary: res.data.JobSeeker_List.current_salary,
          experience: res.data.JobSeeker_List.experience,
          job_role: res.data.JobSeeker_List.job_role,
          dataSource: res.data.JobSeeker_List.datasource,
          state: res.data.JobSeeker_List.state,
          skills: res.data.JobSeeker_List.skills,
          taluka: res.data.JobSeeker_List.taluka,
          district: res.data.JobSeeker_List.district,
          lastactive: moment(res.data.JobSeeker_List.last_activedate).format("DD-MM-YYYY"),
          modified: moment(res.data.JobSeeker_List.last_modified_dt).format("DD-MM-YYYY"),
          notes:
            res.data.JobSeeker_List.notes === "" ||
            res.data.JobSeeker_List.notes === "nan" ||
            res.data.JobSeeker_List.notes === null
              ? ""
              : res.data.JobSeeker_List?.notes,
        });
        console.log(res?.data?.JobSeeker_List, "poison");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleFetchorg = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/transactions/dropdown/org`,
        {
          params: {
            cp_id: cpId,
            // counsellor_id: sessionStorage.getItem("cons_id"),
          },
        }
      )
      .then((res) => {
        console.log(res);
        setOrgList(res?.data["Organisation Name"]);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const stageoptions = [
    { label: "Interested", value: -1 },
    { label: "Under Verification", value: 0 },
    { label: "Onboarded", value: 1 },
  ];
  const handleDynamicSearch = async () => {
    setIsLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/dynamic/search`,
        {
          search_data: name,
          limit: pageSize,
          offset: paginationState.page - 1,
          cpid: cpId,
          jobid: courseId,
        }
      )
      .then((res) => {
        setSearchData(
          res.data["search_data"]?.map((ele, id) => ({
            key: ele.registration_id,
            registration_id: ele.registration_id,
            created_date:
              ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                ? ""
                : moment(ele.createddt).format("DD-MM-YYYY"),
            first_name: ele.first_name,
            last_name: ele.last_name,
            candidate: `${ele.first_name} ${ele.last_name}`,
            date_of_birth: ele.date_of_birth ? moment(ele.date_of_birth).format("DD-MM-YYYY") : "",
            mobile: ele.mobile?.length === 12 ? ele.mobile?.substring(2) : ele.mobile,
            email: ele.email === "nan" ? "" : ele.email,
            gender: ele.gender === "nan" ? "" : ele.gender,
            state: ele.state === "nan" ? "" : ele.state,
            district: ele.district === "nan" ? "" : ele.district,
            taluka: ele.taluka === "nan" ? "" : ele.taluka,
            highest_education:
              ele.highest_education === "nan" ||
              ele.highest_education === "" ||
              ele.highest_education === null
                ? ""
                : ele.highest_education,
            degree: ele.degree === "nan" ? "" : ele.degree,
            stream: ele.stream === "nan" ? "" : ele.stream,
            experience: ele.experience === "nan" ? "" : ele.experience,
            current_salary: ele.current_salary === "nan" ? "" : ele.current_salary,
            desired_salary: ele.desired_salary === "nan" ? "" : ele.desired_salary,
            job_role: ele.job_role === "nan" ? "" : ele.job_role,
            industry: ele.industry === "nan" ? "" : ele.industry,
            marital_status: ele.marital_status === "nan" ? "" : ele.marital_status,
            skills: ele.skills === "nan" ? "" : ele.skills,
            part_time: ele.part_time,
            specially_abled: ele.specially_abled,
            job_priority: ele.job_priority,
            resume_cv: ele.resume_cv === "nan" ? "" : ele.resume_cv,
            last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
            last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
            data_status_type: ele.data_status_type,
            wa_optin: ele.wa_optin,
            datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
            createddt: moment(ele.createddt).format("DD-MM-YYYY"),
            modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
            languages: ele.languages === "nan" ? "" : ele.languages,
            age: ele.age,
            ///////// stages data////////
            feedback: ele.feedback,
            sent_status: ele.sent_status,
            broadcast_status: ele.broadcast_status,
            ratings: ele.ratings,
            // stage: ele.stage,
            // completion_status: ele.completion_status,
            // candidate_status: ele.candidate_status,
            stage: ele.stage ? ele.stage : 0,
            completion_status: ele.completion_status ? ele.completion_status : "in_progress",
            candidate_status: ele.status ? ele.status : "Interested",
            display_comment: ele.display_comment,
          }))
        );
        Setadmindata(
          res.data["search_data"]?.map((ele, id) => ({
            key: ele.registration_id,
            registration_id: ele.registration_id,
            created_date:
              ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                ? ""
                : moment(ele.createddt).format("DD-MM-YYYY"),
            first_name: ele.first_name,
            last_name: ele.last_name,
            candidate: `${ele.first_name} ${ele.last_name}`,
            date_of_birth: ele.date_of_birth ? moment(ele.date_of_birth).format("DD-MM-YYYY") : "",
            mobile: ele.mobile?.length === 12 ? ele.mobile?.substring(2) : ele.mobile,
            email: ele.email === "nan" ? "" : ele.email,
            gender: ele.gender === "nan" ? "" : ele.gender,
            state: ele.state === "nan" ? "" : ele.state,
            district: ele.district === "nan" ? "" : ele.district,
            taluka: ele.taluka === "nan" ? "" : ele.taluka,
            highest_education: ele.highest_education === "nan" ? "" : ele.highest_education,
            degree: ele.degree === "nan" ? "" : ele.degree,
            stream: ele.stream === "nan" ? "" : ele.stream,
            experience: ele.experience === "nan" ? "" : ele.experience,
            current_salary: ele.current_salary === "nan" ? "" : ele.current_salary,
            desired_salary: ele.desired_salary === "nan" ? "" : ele.desired_salary,
            job_role: ele.job_role === "nan" ? "" : ele.job_role,
            industry: ele.industry === "nan" ? "" : ele.industry,
            marital_status: ele.marital_status === "nan" ? "" : ele.marital_status,
            skills: ele.skills === "nan" ? "" : ele.skills,
            part_time: ele.part_time,
            specially_abled: ele.specially_abled,
            job_priority: ele.job_priority,
            resume_cv: ele.resume_cv === "nan" ? "" : ele.resume_cv,
            last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
            last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
            data_status_type: ele.data_status_type,
            wa_optin: ele.wa_optin,
            datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
            createddt: moment(ele.createddt).format("DD-MM-YYYY"),
            modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
            languages: ele.languages === "nan" ? "" : ele.languages,
            age: ele.age,
            ///////// stages data////////
            feedback: ele.feedback,
            sent_status: ele.sent_status,
            broadcast_status: ele.broadcast_status,
            ratings: ele.ratings,
            // stage: ele.stage,
            // completion_status: ele.completion_status,
            // candidate_status: ele.candidate_status,
            stage: ele.stage ? ele.stage : 0,
            completion_status: ele.completion_status ? ele.completion_status : "in_progress",
            candidate_status: ele.status ? ele.status : "Interested",
            display_comment: ele.display_comment,
          }))
        );
        setPaginationState({ ...paginationState, dataSize: res.data["count"] });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const handleFetchjob = () => {
    axios
      // .get(
      //   `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/transactions/dropdown/org`,
      //   {
      //     params: {
      //       cp_id: cpId,
      //       org_id: orgId,
      //       // counsellor_id: sessionStorage.getItem("cons_id"),
      //     },
      //   }
      // )
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/courses/course_names`, {
        params: {
          cp_id: cpId,
          // org_id: orgId,
          // counsellor_id: sessionStorage.getItem("cons_id"),
        },
      })
      .then((res) => {
        console.log(res, "joblist");
        setJobList(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleFetchBatches = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/${courseId}/fetch-batch`)
      .then((res) => {
        console.log(res, "batchlist");
        setBatchList(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleKPIs = async () => {
    setFetching(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/kpi`, {
        params: {
          cpid: cpId,
          orgid: orgId,
          jobid: courseId,
        },
      })
      .then((res) => {
        setFetching(false);
        setKPIObj({
          candidate_upload_count: res.data["Candidate KPI"].candidate_upload_count,
          job_accepted_count: res.data["Candidate KPI"].job_accepted_count,
          job_assigned_count: res.data["Candidate KPI"].job_assigned_count,
          pipeline_count: res.data["Candidate KPI"].pipeline_count,
          placed_count: res.data["Candidate KPI"].placed_count,
          expectedCost: res.data["Candidate KPI"].expected
            ? res.data["Candidate KPI"].expected
            : "0",
          actualCost: res.data["Candidate KPI"].actual ? res.data["Candidate KPI"].actual : "0",
          formLink: res.data["Candidate KPI"].form_link,
          qrLink: res.data["Candidate KPI"].qr_code,
        });
      })
      .catch((err) => {
        setFetching(false);
      });
  };

  const fetchTable1 = async () => {
    setIsLoading(true);
    try {
      // const res = await axios.get(
      //   `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/self_employement`,
      //   {
      //     params: {
      //       cpid: cpId,
      //     },
      //   }
      // );
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/crm/${courseId}/fetch-learners`,
        {
          params: {
            search: 1,
            batch_id: batchId,
          },
        }
      );
      const data = await res.data;
      data.length === 0
        ? setTable1([])
        : setTable1(
            data?.map((ele, id) => ({
              key: ele.candid,
              registration_id: ele.candid,
              first_name: ele.firstname,
              last_name: ele.lastname,
              candidate: `${ele.firstname} ${ele.lastname}`,
              date_of_birth: moment(ele.date_of_birth).format("DD-MM-YYYY"),
              mobile: ele?.mobnum?.length === 12 ? ele?.mobnum?.substring(2) : ele.mobnum,
              email: ele.email ? ele.email : "",
              gender: ele.gender ? ele.gender : "",
              state: ele.state ? (ele.state !== "nan" ? ele.state : "") : "",
              district: ele.district ? (ele.district !== "nan" ? ele.district : "") : "",
              taluka: ele.taluka ? ele.taluka : "",
              highest_education: ele.highest_education
                ? ele.highest_education !== "nan"
                  ? ele.highest_education
                  : ""
                : "",
              degree: ele.degree ? ele.degree : "",
              stream: ele.stream ? ele.stream : "",
              experience: ele.experience ? ele.experience : "",
              current_salary: ele.current_salary ? ele.current_salary : "",
              desired_salary: ele.desired_salary ? ele.desired_salary : "",
              job_role: ele.job_role ? ele.job_role : "",
              industry: ele.industry ? ele.industry : "",
              marital_status: ele.marital_status ? ele.marital_status : "",
              skills: ele.skills ? (ele.skills !== "nan" ? ele.skills : "") : "",
              part_time: ele.part_time ? ele.part_time : "",
              specially_abled: ele.specially_abled ? ele.specially_abled : "",
              job_priority: ele.job_priority ? ele.job_priority : "",
              resume_cv: ele.resume_cv ? ele.resume_cv : "",
              last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
              last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
              data_status_type: ele.data_status_type,
              wa_optin: ele.wa_optin,
              datasource: ele.datasource,
              createddt: moment(ele.createddt).format("DD-MM-YYYY"),
              modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
              ///////// stages data////////
              feedback: ele.feedback,
              sent_status: ele.sent_status,
              broadcast_status: ele.broadcast_status,
              ratings: ele.ratings,
              stage: ele.stage,
              completion_status: ele.completion_status,
              candidate_status: ele.status ? ele.status : "Interested",
              display_comment: ele.display_comment,
              batch_name: ele.batch_name !== "" ? ele.batch_name : " - ",
            }))
          );
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      // setTable1([
      //   {
      //     key: 1,
      //     candidate: "XYZ",
      //     mobile: "",
      //     highest_education: "",
      //     skills: "",
      //     state: "",
      //     district: "",
      //     documents: [
      //       { name: "Aadhaar", value: "www.google.com" },
      //       { name: "Pan Card", value: "www.google.com" },
      //       { name: "Mark Sheet", value: "www.google.com" },
      //     ],
      //     candidate_status: true,
      //   },
      //   {
      //     key: 2,
      //     candidate: "ABC",
      //     mobile: "",
      //     highest_education: "",
      //     skills: "",
      //     state: "",
      //     district: "",
      //     documents: [
      //       { name: "Aadhaar", value: "www.google.com" },
      //       { name: "Pan Card", value: "www.google.com" },
      //       { name: "Mark Sheet", value: "www.google.com" },
      //     ],
      //     candidate_status: false,
      //   },
      // ]);
    }
  };

  const fetchTable2 = async () => {
    setIsLoading(true);
    try {
      // const res = await axios.get(
      //   `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/skilling`,
      //   {
      //     params: {
      //       cpid: cpId,
      //     },
      //   }
      // );
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/crm/${courseId}/fetch-learners`,
        {
          params: {
            search: 2,
            batch_id: batchId,
          },
        }
      );
      const data = await res.data;
      console.log(data, "table2");
      data.length === 0
        ? setTable2([])
        : setTable2(
            data?.map((ele, id) => ({
              key: ele.candid,
              registration_id: ele.candid,
              candid: ele.candid,
              first_name: ele.firstname,
              last_name: ele.lastname,
              candidate: `${ele.firstname} ${ele.lastname}`,
              date_of_birth: moment(ele.date_of_birth).format("DD-MM-YYYY"),
              mobile: ele?.mobnum?.length === 12 ? ele?.mobnum?.substring(2) : ele.mobnum,
              email: ele.email,
              gender: ele.gender,
              state: ele.state,
              district: ele.district,
              taluka: ele.taluka,

              highest_education: ele.highest_education,
              degree: ele.degree,
              stream: ele.stream,
              experience: ele.experience,
              current_salary: ele.current_salary,
              desired_salary: ele.desired_salary,
              job_role: ele.job_role,
              industry: ele.industry,
              marital_status: ele.marital_status,
              skills: ele.skills,
              attendence_count: ele.attendance_count !== null ? ele.attendance_count : "",
              attendence_status:
                ele.attendance_status !== null
                  ? ele.attendance_status === "Irregular"
                    ? "Irregular"
                    : "Regular"
                  : "",
              test_status: ele.test_status !== null ? ele.test_status : "",
              ojt_status: ele.ojt_status !== null ? ele.ojt_status : "",
              placement_status: ele.placed !== null ? (ele.placed === 1 ? "Yes" : "No") : "No",
              part_time: ele.part_time,
              specially_abled: ele.specially_abled,
              job_priority: ele.job_priority,
              resume_cv: ele.resume_cv,
              last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
              last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
              data_status_type: ele.data_status_type,
              wa_optin: ele.wa_optin,
              datasource: ele.datasource,
              createddt: moment(ele.createddt).format("DD-MM-YYYY"),
              modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
              ///////// stages data////////
              feedback: ele.feedback,
              sent_status: ele.sent_status,
              broadcast_status: ele.broadcast_status,
              ratings: ele.ratings,
              stage: ele.stage,
              completion_status: ele.completion_status,
              candidate_status: ele.status ? ele.status : "Interested",
              display_comment: ele.display_comment,
              batch_name: ele.batch_name !== "" ? ele.batch_name : " - ",
              batch_id: ele.batch_id !== "" ? ele.batch_id : " - ",
              candidate_certificate: ele.candidate_certificate,
              self_employed: ele.self_employed,
            }))
          );
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      // setTable2([
      //   {
      //     key: 1,
      //     candidate: "XYZ",
      //     email: "",
      //     mobile: "",
      //     attendence_count: "40/60",
      //     attendence_status: "Regular",
      //     test_status: "Done",
      //     ojt_status: "Not Done",
      //     placement_status: "No",
      //   },
      //   {
      //     key: 2,
      //     candidate: "XYZ",
      //     email: "",
      //     mobile: "",
      //     attendence_count: "40/60",
      //     attendence_status: "Irregular",
      //     test_status: "Passed ",
      //     ojt_status: "Done",
      //     placement_status: "Yes",
      //   },
      //   {
      //     key: 3,
      //     candidate: "XYZ",
      //     email: "",
      //     mobile: "",
      //     attendence_count: "40/60",
      //     attendence_status: "Regular",
      //     test_status: "Failed ",
      //     ojt_status: "Not Done",
      //     placement_status: "No",
      //   },
      //   {
      //     key: 4,
      //     candidate: "XYZ",
      //     email: "",
      //     mobile: "",
      //     attendence_count: "40/60",
      //     attendence_status: "Irregular",
      //     test_status: "Failed ",
      //     ojt_status: "Done",
      //     placement_status: "Yes",
      //   },
      // ]);
    }
  };
  const fetchTable3 = async () => {
    setIsLoading(true);
    setSelectedRowKeys([]);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/crm/${courseId}/fetch-learners`,
        {
          params: {
            search: 3,
            batch_id: batchId,
          },
        }
      );
      const data = await res.data;
      console.log(data, "table2");
      data.length === 0
        ? setSearchData([])
        : setSearchData(
            res.data?.map((ele, id) => ({
              key: ele.candid,
              candid: ele.candid,
              created_date:
                ele.modifieddt === "" || ele.modifieddt === "nan" || ele.modifieddt === null
                  ? ""
                  : moment(ele.modifieddt).format("DD-MM-YYYY"),
              first_name: ele.firstname,
              last_name: ele.lastname,
              candidate: `${ele.firstname} ${ele.lastname}`,
              date_of_birth: ele.date_of_birth
                ? moment(ele.date_of_birth).format("DD-MM-YYYY")
                : "",
              mobile: ele.mobnum?.length === 12 ? ele.mobnum?.substring(2) : ele.mobnum,
              email: ele.email === "nan" || ele.email === null || ele.email === "" ? "" : ele.email,
              gender:
                ele.gender === "nan" || ele.gender === "" || ele.gender === null ? "" : ele.gender,
              state: ele.state === "nan" || ele.state === "" || ele.state === null ? "" : ele.state,
              district:
                ele.district === "nan" || ele.district === "" || ele.district === null
                  ? ""
                  : ele.district,
              taluka:
                ele.taluka === "nan" || ele.taluka === "" || ele.taluka === null ? "" : ele.taluka,
              highest_education:
                ele.highest_education === "nan" ||
                ele.highest_education === "" ||
                ele.highest_education === null
                  ? ""
                  : ele.highest_education,
              degree:
                ele.degree === "nan" || ele.degree === "" || ele.degree === null ? "" : ele.degree,
              stream:
                ele.stream === "nan" || ele.stream === "" || ele.stream === null ? "" : ele.stream,
              experience:
                ele.experience === "nan" || ele.experience === "" || ele.experience === null
                  ? ""
                  : ele.experience,
              current_salary:
                ele.current_salary === "nan" ||
                ele.current_salary === "" ||
                ele.current_salary === null
                  ? ""
                  : ele.current_salary,
              desired_salary:
                ele.desired_salary === "nan" ||
                ele.desired_salary === "" ||
                ele.desired_salary === null
                  ? ""
                  : ele.desired_salary,
              job_role:
                ele.job_role === "nan" || ele.job_role === "" || ele.job_role === null
                  ? ""
                  : ele.job_role,
              industry:
                ele.industry === "nan" || ele.industry === "" || ele.industry === null
                  ? ""
                  : ele.industry,
              marital_status:
                ele.marital_status === "nan" ||
                ele.marital_status === "" ||
                ele.marital_status === null
                  ? ""
                  : ele.marital_status,
              skills:
                ele.skills === "nan" || ele.skills === "" || ele.skills === null ? "" : ele.skills,
              part_time: ele.part_time,
              specially_abled: ele.specially_abled,
              job_priority: ele.job_priority,
              resume_cv:
                ele.resume_cv === "nan" || ele.resume_cv === "" || ele.resume_cv === null
                  ? ""
                  : ele.resume_cv,
              last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
              last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
              data_status_type: ele.data_status_type,
              wa_optin: ele.wa_optin,
              datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
              createddt: moment(ele.createddt).format("DD-MM-YYYY"),
              modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
              languages:
                ele.languages === "nan" || ele.languages === "" || ele.languages === null
                  ? ""
                  : ele.languages,
              age: ele.age,
              ///////// stages data////////
              feedback:
                ele.feedback === "nan" || ele.feedback === "" || ele.feedback === null
                  ? ""
                  : ele.feedback,
              sent_status: ele.sent_status,
              broadcast_status: ele.broadcast_status,
              ratings: ele.ratings,
              // stage: ele.stage,
              // completion_status: ele.completion_status,
              // candidate_status: ele.candidate_status,
              stage: ele.stage ? ele.stage : 0,
              completion_status: ele.completion_status ? ele.completion_status : "in_progress",
              candidate_status: ele.status ? ele.status : "Interested",
              display_comment:
                ele.display_comment === "" ||
                ele.display_comment === "nan" ||
                ele.display_comment === null
                  ? ""
                  : ele.display_comment,
              batch_name: ele.batch_name !== "" ? ele.batch_name : " - ",
            }))
          );
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    tableshow === 1 && fetchTable1();
    tableshow === 2 && fetchTable2();
    tableshow === 3 && fetchTable3();
    tableshow === 0 && fetchCandidates();
  }, [tableshow]);
  const handleMenuClick = (e, record) => {
    // console.log("Click on menu item:", e);
    console.log("Row data:", record);
    if (e.key == 1) {
      setViewAttd(true), setCanId(record.candid), fetchAttdFunc(record.candid);
    } else if (e.key == 3) {
      downloadFile(record);
    } else {
      setUploadMedia(true);
      setBatchDetail(record);
      console.log("batchDetail", record);
    }
  };
  const menu = (record) => (
    <Menu onClick={(e) => handleMenuClick(e, record)}>
      <Menu.Item key="1">
        <a style={{ display: "flex" }} className="dropdown-item" href="#EditUser">
          <div>
            {/* <Icon icon="uil:file-upload-alt" width="20" height="20" /> */}
            <Icon icon="hugeicons:file-view" width="20" height="20" style={{ color: "black" }} />
          </div>
          &nbsp; View Attendance
        </a>
      </Menu.Item>
      <Menu.Item key="2">
        <a style={{ display: "flex" }} className="dropdown-item" href="#EditUser">
          <div>
            <Icon icon="uil:file-upload-alt" width="20" height="20" />
          </div>
          &nbsp; Upload Feedback
        </a>
      </Menu.Item>
      {record.candidate_certificate !== "" && (
        <Menu.Item key="3">
          <a style={{ display: "flex" }} className="dropdown-item">
            <div>
              <Icon icon="hugeicons:file-view" width="20" height="20" style={{ color: "black" }} />
            </div>
            &nbsp; View Certificate
          </a>
        </Menu.Item>
      )}
    </Menu>
  );

  const ResumeUploadFunc = async (data) => {
    console.log("resume row:", data);
    let docData = new FormData();
    docData.append("jsid", data.key);
    docData.append("type", "resume");
    docData.append("resume", resumefile);
    // docData.append("updatedby", registerID);
    await axios
      .patch(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/register/jobseeker/register`,
        docData
      )
      .then((res) => {
        console.log("upload", res);
        Swal.fire({
          icon: "success",
          title: "",
          text: res?.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        }).then(() => setResumeModal(false));
      })
      .catch((err) => {
        console.log("upload", err);
        Swal.fire({
          icon: "error",
          title: err?.data["Developer Message"] ? err?.data["Developer Message"] : "Oops...",
          text: err?.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };

  const colName = [
    {
      title: "Upload Date",
      //dataIndex: "candidate_date",
      key: "created_date",
      width: 100,
      fixed: "left",
      sorter: {
        compare: (a, b) => a?.created_date - b?.created_date,
        multiple: 1,
      },
      render: (text) => <>{text.created_date === "" ? "-" : text.created_date}</>,
    },
    {
      title: "Candidate Name",
      //dataIndex: "candidate",
      key: "candidate",
      width: 150,
      fixed: "left",
      sorter: {
        compare: (a, b) => a?.candidate?.localeCompare(b?.candidate),
        multiple: 1,
      },
      render: (text, record) => (
        <p
          //   onClick={() => {
          //     setCanId(record.key);
          //     HandleFetchCandDetails(record.key);
          //   }}
          style={{
            cursor: "pointer",
            marginBottom: "-2px",
            color: "#3B5092",
            textDecorationLine: "underline",
          }}
        >
          {/* {`${text.first_name}` + " " + `${text.last_name}`} */}
          {`${text.candidate}`}
        </p>
      ),
    },
    {
      title: "Batch Name",
      dataIndex: "batch_name",
      key: "batch_name",
      width: 150,
      sorter: {
        compare: (a, b) => a?.batch_name?.localeCompare(b?.batch_name),
        multiple: 2,
      },
    },
    {
      title: "Phone Number",
      dataIndex: "mobile",
      key: "mobile",
      width: 150,
      sorter: {
        compare: (a, b) => a.mobile - b.mobile,
        multiple: 2,
      },
    },
    // {
    //   title: "Email",
    //   //dataIndex: "taluka",
    //   key: "email",
    //   width: 250,
    //   sorter: {
    //     compare: (a, b) => a?.email?.localeCompare(b?.email),
    //     multiple: 7,
    //   },
    //   render: (text) => <>{text.email === "" ? "-" : text.email}</>,
    // },
    {
      title: "Gender",
      //dataIndex: "state",
      key: "gender",
      width: 150,
      sorter: {
        compare: (a, b) => a?.gender?.localeCompare(b?.gender),
        multiple: 6,
      },
      render: (text) => <>{text.gender === "" ? "-" : text.gender}</>,
    },

    {
      title: "State",
      //dataIndex: "state",
      key: "state",
      width: 200,
      sorter: {
        compare: (a, b) => a?.state?.localeCompare(b?.state),
        multiple: 6,
      },
      render: (text) => <>{text.state === "" ? "-" : text.state}</>,
    },
    {
      title: "District",
      //dataIndex: "district",
      key: "district",
      width: 150,
      sorter: {
        compare: (a, b) => a?.district?.localeCompare(b?.district),
        multiple: 7,
      },
      render: (text) => <>{text.district === "" ? "-" : text.district}</>,
    },
    // {
    //   title: "Status",
    //   //   dataIndex: "status",
    //   //   sorter: {
    //   //     compare: (a, b) => a?.status?.localeCompare(b?.status),
    //   //     multiple: 8,
    //   //   },
    //   key: "candidate_status",
    //   width: 150,

    //   render: (text) => (
    //     <span
    //       style={{
    //         backgroundColor:
    //           text.completion_status === "completed"
    //             ? "#BDFDC8"
    //             : text.completion_status === "rejected"
    //             ? "#EFD6FF"
    //             : "#FFE1C3",
    //         color:
    //           text.completion_status === "completed"
    //             ? "#049C2F"
    //             : text.completion_status === "rejected"
    //             ? "#62049C"
    //             : "#EA7500",
    //         paddingTop: "5px",
    //         paddingBottom: "5px",
    //         paddingLeft: "10px",
    //         paddingRight: "10px",
    //         borderRadius: "50px",
    //       }}
    //     >
    //       {text.candidate_status}
    //     </span>
    //   ),
    // },
  ];

  const colName1 = [
    {
      title: "Candidate Name",
      dataIndex: "candidate",
      width: 150,
      fixed: "left",
      sorter: {
        compare: (a, b) => a?.candidate?.localeCompare(b?.candidate),
        multiple: 1,
      },
    },
    {
      title: "Batch Name",
      dataIndex: "batch_name",
      key: "batch_name",
      width: 150,
      sorter: {
        compare: (a, b) => a?.batch_name?.localeCompare(b?.batch_name),
        multiple: 2,
      },
    },
    {
      title: "Phone Number",
      dataIndex: "mobile",
      width: 150,
      sorter: {
        compare: (a, b) => a.mobile - b.mobile,
        multiple: 2,
      },
    },
    {
      title: "Education",
      // dataIndex: "highest_education",
      key: "highest_education",
      width: 200,
      sorter: {
        compare: (a, b) => a?.highest_education?.localeCompare(b?.highest_education),
        multiple: 3,
      },
      render: (text) => <>{text.highest_education === "" ? "-" : text.highest_education}</>,
    },
    // {
    //   title: "Role",
    //   dataIndex: "job_role",
    //   width: 200,
    //   sorter: {
    //     compare: (a, b) => a?.job_role?.localeCompare(b?.job_role),
    //     multiple: 4,
    //   },
    // },
    {
      title: "Skills",
      // dataIndex: "skills",
      key: "skills",
      width: 200,
      sorter: {
        compare: (a, b) => a?.skills?.localeCompare(b?.skills),
        multiple: 5,
      },
      render: (text) => <>{text.skills === "" ? "-" : text.skills}</>,
    },
    {
      title: "State",
      //dataIndex: "state",
      key: "state",
      width: 200,
      sorter: {
        compare: (a, b) => a?.state?.localeCompare(b?.state),
        multiple: 6,
      },
      render: (text) => <>{text.state === "" ? "-" : text.state}</>,
    },
    {
      title: "District",
      //dataIndex: "district",
      key: "district",
      width: 150,
      sorter: {
        compare: (a, b) => a?.district?.localeCompare(b?.district),
        multiple: 7,
      },
      render: (text) => <>{text.district === "" ? "-" : text.district}</>,
    },
    // {
    //   title: "Documents",
    //   // dataIndex: "documents",
    //   key: "documents",
    //   width: 150,
    //   // sorter: {
    //   //   compare: (a, b) => a?.district?.localeCompare(b?.district),
    //   //   multiple: 7,
    //   // },
    //   render: (text) => {
    //     return (
    //       <p
    //         style={{
    //           color: "3B5092",
    //           textDecoration: "underline",
    //           textAlign: "center",
    //           cursor: "pointer",
    //         }}
    //         onClick={() => (setViewDocsModal(true), setAllDocs(text.documents))}
    //       >
    //         View
    //       </p>
    //     );
    //   },
    // },
    // {
    //   title: "Status",
    //   // dataIndex: "candidate_status",
    //   key: "candidate_status",
    //   width: 150,
    //   // sorter: {
    //   //   compare: (a, b) => a?.district?.localeCompare(b?.district),
    //   //   multiple: 7,
    //   // },
    //   render: (text) => {
    //     return (
    //       <div
    //         style={{
    //           backgroundColor: text.candidate_status ? "#BDFDC8" : "#FFE1C3",
    //           color: text.candidate_status ? "#049C2F" : "#EA7500",
    //           paddingTop: "5px",
    //           paddingBottom: "5px",
    //           paddingLeft: "10px",
    //           paddingRight: "10px",
    //           borderRadius: "50px",
    //           textAlign: "center",
    //         }}
    //       >
    //         {text.candidate_status ? "Completed" : "Ongoing"}
    //       </div>
    //     );
    //   },
    // },
  ];
  const colName2 = [
    {
      title: "Candidate Name",
      dataIndex: "candidate",
      key: "candidate",
      width: 150,
      fixed: "left",
      sorter: {
        compare: (a, b) => a?.candidate?.localeCompare(b?.candidate),
        multiple: 1,
      },
    },
    {
      title: "Batch Name",
      dataIndex: "batch_name",
      key: "batch_name",
      width: 150,
      sorter: {
        compare: (a, b) => a?.batch_name?.localeCompare(b?.batch_name),
        multiple: 2,
      },
    },
    {
      title: "Phone Number",
      dataIndex: "mobile",
      key: "mobile",
      width: 150,
      sorter: {
        compare: (a, b) => a.mobile - b.mobile,
        multiple: 2,
      },
    },
    {
      title: "Attendance Count",
      dataIndex: "attendence_count",
      key: "attendence_count",
      width: 100,
      sorter: {
        compare: (a, b) => a.attendence_count - b.attendence_count,
        multiple: 2,
      },
    },
    {
      title: "Attendance Status",
      // dataIndex: "mobile",
      key: "attendence_status",
      width: 100,
      render: (text) => {
        return (
          <Box sx={{ padding: "5px 7px" }}>
            <Box
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                // color: "#6C6C6C",
                fontStyle: "normal",
                fontFamily: "Public Sans",
                // textAlign: "center",
              }}
            >
              {/* {"Total Placed : "} */}
              <span style={{ color: text.attendence_status === "Regular" ? "#0B7B2A" : "#FF0000" }}>
                {text.attendence_status}
              </span>
            </Box>
          </Box>
        );
      },
    },
    {
      title: "Test Status",
      // dataIndex: "mobile",
      key: "test_status",
      width: 100,
      render: (text) => {
        return (
          <Box sx={{ padding: "5px 7px" }}>
            <Box
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                // color: "#6C6C6C",
                fontStyle: "normal",
                fontFamily: "Public Sans",
                // textAlign: "center",
              }}
            >
              {/* {"Total Placed : "} */}
              <span
                style={{
                  color:
                    text.test_status === "Passed"
                      ? "#0B7B2A"
                      : text.test_status === "Failed"
                      ? "#FF0000"
                      : text.test_status === "Done"
                      ? "#0B7B2A"
                      : "#FF7500",
                }}
              >
                {text.test_status !== "" ? text.test_status : "-"}
              </span>
            </Box>
          </Box>
        );
      },
    },
    {
      title: "OJT Status",
      // dataIndex: "mobile",
      key: "ojt_status",
      width: 100,
      render: (text) => {
        return (
          <Box sx={{ padding: "5px 7px" }}>
            <Box
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                // color: "#6C6C6C",
                fontStyle: "normal",
                fontFamily: "Public Sans",
                // textAlign: "center",
              }}
            >
              {/* {"Total Placed : "} */}
              <span style={{ color: text.ojt_status === "Done" ? "#0B7B2A" : "#FF7500" }}>
                {text.ojt_status !== "" ? text.ojt_status : "-"}
              </span>
            </Box>
          </Box>
        );
      },
    },
    {
      title: "Placement Status",
      // dataIndex: "mobile",
      key: "placement_status",
      width: 100,
      render: (text) => {
        return (
          <Box sx={{ padding: "5px 7px" }}>
            <Box
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                // color: "#6C6C6C",
                fontStyle: "normal",
                fontFamily: "Public Sans",
                // textAlign: "center",
              }}
            >
              {/* {"Total Placed : "} */}
              <span style={{ color: text.placement_status === "Yes" ? "#0B7B2A" : "#FF0000" }}>
                {text.placement_status !== "" ? text.placement_status : "-"}
              </span>
            </Box>
          </Box>
        );
      },
    },
    {
      title: "Self Employee Status",
      // dataIndex: "mobile",
      key: "self_employed",
      width: 100,
      render: (text) => {
        return (
          <Box sx={{ padding: "5px 7px" }}>
            <Box
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                // color: "#6C6C6C",
                fontStyle: "normal",
                fontFamily: "Public Sans",
                // textAlign: "center",
              }}
            >
              {/* {"Total Placed : "} */}
              <span style={{ color: text.self_employed === "Yes" ? "#0B7B2A" : "#FF0000" }}>
                {text.self_employed !== "" ? text.self_employed : "-"}
              </span>
            </Box>
          </Box>
        );
      },
    },
    // {
    //   title: "View Attendance",
    //   // key: "documents",
    //   width: 80,
    //   render: (text) => {
    //     return (
    //       <p
    //         style={{
    //           color: "3B5092",
    //           textDecoration: "underline",
    //           // textAlign: "center",
    //           // textDecoration:"underline",
    //           cursor: "pointer",
    //         }}
    //         onClick={() => (setViewAttd(true), setCanId(text.candid), fetchAttdFunc(text.candid))}
    //       >
    //         View
    //       </p>
    //     );
    //   },
    // },
    {
      title: "Action",
      // dataIndex: "action",
      width: 100,
      // fixed: !matchsm ? "left" : "none",
      // sorter: {
      //   compare: (a, b) => a?.total_ojt - b?.total_ojt,
      //   multiple: 1,
      // },
      render: (text, record) => (
        <span style={{ display: "flex", justifyContent: "center" }}>
          <Dropdown overlay={() => menu(record)}>
            <a>
              <Icon icon="ion:ellipsis-vertical" color="black" />
            </a>
          </Dropdown>
        </span>
      ),
    },
  ];
  const colName3 = [
    {
      title: "Dropout Date",
      //dataIndex: "candidate_date",
      key: "created_date",
      width: 150,
      fixed: "left",
      sorter: {
        compare: (a, b) => a?.created_date - b?.created_date,
        multiple: 1,
      },
      render: (text) => <>{text.created_date === "" ? "-" : text.created_date}</>,
    },
    {
      title: "Candidate Name",
      //dataIndex: "candidate",
      key: "candidate",
      width: 200,
      fixed: "left",
      sorter: {
        compare: (a, b) => a?.candidate?.localeCompare(b?.candidate),
        multiple: 1,
      },
      render: (text, record) => (
        <p
          //   onClick={() => {
          //     setCanId(record.key);
          //     HandleFetchCandDetails(record.key);
          //   }}
          style={{
            cursor: "pointer",
            marginBottom: "-2px",
            color: "#3B5092",
            textDecorationLine: "underline",
          }}
        >
          {/* {`${text.first_name}` + " " + `${text.last_name}`} */}
          {`${text.candidate}`}
        </p>
      ),
    },
    {
      title: "Batch Name",
      dataIndex: "batch_name",
      key: "batch_name",
      width: 150,
      sorter: {
        compare: (a, b) => a?.batch_name?.localeCompare(b?.batch_name),
        multiple: 2,
      },
    },
    {
      title: "Phone Number",
      dataIndex: "mobile",
      key: "mobile",
      width: 150,
      sorter: {
        compare: (a, b) => a.mobile - b.mobile,
        multiple: 2,
      },
    },
    // {
    //   title: "Email",
    //   //dataIndex: "taluka",
    //   key: "email",
    //   width: 250,
    //   sorter: {
    //     compare: (a, b) => a?.email?.localeCompare(b?.email),
    //     multiple: 7,
    //   },
    //   render: (text) => <>{text.email === "" ? "-" : text.email}</>,
    // },
    {
      title: "Gender",
      //dataIndex: "state",
      key: "gender",
      width: 150,
      sorter: {
        compare: (a, b) => a?.gender?.localeCompare(b?.gender),
        multiple: 6,
      },
      render: (text) => <>{text.gender === "" ? "-" : text.gender}</>,
    },

    {
      title: "State",
      //dataIndex: "state",
      key: "state",
      width: 200,
      sorter: {
        compare: (a, b) => a?.state?.localeCompare(b?.state),
        multiple: 6,
      },
      render: (text) => <>{text.state === "" ? "-" : text.state}</>,
    },
    {
      title: "District",
      //dataIndex: "district",
      key: "district",
      width: 150,
      sorter: {
        compare: (a, b) => a?.district?.localeCompare(b?.district),
        multiple: 7,
      },
      render: (text) => <>{text.district === "" ? "-" : text.district}</>,
    },
    // {
    //   title: "Status",
    //   //   dataIndex: "status",
    //   //   sorter: {
    //   //     compare: (a, b) => a?.status?.localeCompare(b?.status),
    //   //     multiple: 8,
    //   //   },
    //   key: "candidate_status",
    //   width: 150,

    //   render: (text) => (
    //     <span
    //       style={{
    //         backgroundColor:
    //           text.completion_status === "completed"
    //             ? "#BDFDC8"
    //             : text.completion_status === "rejected"
    //             ? "#EFD6FF"
    //             : "#FFE1C3",
    //         color:
    //           text.completion_status === "completed"
    //             ? "#049C2F"
    //             : text.completion_status === "rejected"
    //             ? "#62049C"
    //             : "#EA7500",
    //         paddingTop: "5px",
    //         paddingBottom: "5px",
    //         paddingLeft: "10px",
    //         paddingRight: "10px",
    //         borderRadius: "50px",
    //       }}
    //     >
    //       {text.candidate_status}
    //     </span>
    //   ),
    // },
  ];
  const attdColumn = [
    {
      title: "Date",
      //dataIndex: "candidate_date",
      key: "attendance_date",
      // width: 100,
      // fixed: "left",
      sorter: {
        compare: (a, b) => a?.attendance_date - b?.attendance_date,
        multiple: 1,
      },
      render: (text) => <>{text.attendance_date === "" ? "-" : text.attendance_date}</>,
    },
    {
      title: "Clock In",
      //dataIndex: "candidate_date",
      key: "clock_in",
      // width: 100,
      // fixed: "left",
      sorter: {
        compare: (a, b) => a?.clock_in - b?.clock_in,
        multiple: 1,
      },
      render: (text) => <>{text.clock_in === "" ? "-" : text.clock_in}</>,
    },
    {
      title: "Clock Out",
      //dataIndex: "candidate_date",
      key: "clock_out",
      // width: 100,
      // fixed: "left",
      sorter: {
        compare: (a, b) => a?.clock_out - b?.clock_out,
        multiple: 1,
      },
      render: (text) => <>{text.clock_out === "" ? "-" : text.clock_out}</>,
    },
  ];

  const [colHeaders, setColHeaders] = useState([
    {
      label: "Upload Date",
      key: "created_date",
      isExportable: true,
    },
    {
      label: "Candidate Name",
      key: "candidate",
      isExportable: true,
    },
    {
      label: "Batch Name",
      key: "batch_name",
      isExportable: true,
    },
    {
      label: "Phone Number",
      key: "mobile",
      isExportable: true,
    },
    {
      label: "Email",
      key: "email",
      isExportable: true,
    },
    {
      label: "Gender",
      key: "gender",
      isExportable: true,
    },
    {
      label: "Status",
      key: "candidate_status",
      isExportable: true,
    },
  ]);
  const [colHeaders1, setColHeaders1] = useState([
    // created_date,candidate,mobile,email,gender,highest_education,skills,state,district
    {
      label: "Candidate Name",
      key: "candidate",
      isExportable: true,
    },
    {
      label: "Batch Name",
      key: "batch_name",
      isExportable: true,
    },
    {
      label: "Phone Number",
      key: "mobile",
      isExportable: true,
    },
    {
      label: "Education",
      key: "highest_education",
      isExportable: true,
    },
    {
      label: "Skills",
      key: "skills",
      isExportable: true,
    },
    {
      label: "State",
      key: "state",
      isExportable: true,
    },
    {
      label: "District",
      key: "district",
      isExportable: true,
    },
    {
      label: "Status",
      key: "candidate_status",
      isExportable: true,
    },
  ]);
  const [colHeaders2, setColHeaders2] = useState([
    {
      label: "Candidate Name",
      key: "candidate",
      isExportable: true,
    },
    {
      label: "Batch Name",
      key: "batch_name",
      isExportable: true,
    },
    {
      label: "Phone Number",
      key: "mobile",
      isExportable: true,
    },
    {
      label: "Email",
      key: "email",
      isExportable: true,
    },
    {
      label: "Attendance Count",
      key: "attendence_count",
      isExportable: true,
    },
    {
      label: "Attendance Status",
      key: "attendence_status",
      isExportable: true,
    },
    {
      label: "Test Status",
      key: "test_status",
      isExportable: true,
    },
    {
      label: "OJT Status",
      key: "ojt_status",
      isExportable: true,
    },
    {
      label: "Placement Status",
      key: "placement_status",
      isExportable: true,
    },
    {
      label: "Self Employee Status",
      key: "self_employed",
      isExportable: true,
    },
    {
      label: "Certificate",
      key: "candidate_certificate",
      isExportable: true,
    },
  ]);
  const [colHeaders3, setColHeaders3] = useState([
    {
      label: "Dropout Date",
      key: "created_date",
      isExportable: true,
    },
    {
      label: "Candidate Name",
      key: "candidate",
      isExportable: true,
    },
    {
      label: "Batch Name",
      key: "batch_name",
      isExportable: true,
    },
    {
      label: "Phone Number",
      key: "mobile",
      isExportable: true,
    },
    {
      label: "State",
      key: "state",
      isExportable: true,
    },
    {
      label: "District",
      key: "district",
      isExportable: true,
    },
  ]);
  const handleClick = () => {
    // if (tablerow.length !== 0) {
    //   setShow(!show);
    //   getFileName();
    // } else {
    //   handleDownload();
    // }
    // setShow(!show);
    getFileName();
  };

  const downloadFile = (file) => {
    console.log("certificate:", file.candidate_certificate);
    const linkTag = document.createElement("a");
    linkTag.href = file.candidate_certificate;
    linkTag.target = "_blank";
    document.body.appendChild(linkTag);
    // linkTag.download = `${details?.name}-certificate-${data.candidate}.png`;
    linkTag.click();
    document.body.removeChild(linkTag);
  };

  const handleDownload = async () => {
    setDownloadingModal(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/candidatesearch/downloadallcandidatedata`,
        {
          //responseType: 'arraybuffer',
          // shortlistedid: candidateIdsObj,
          // cpid: cpId,
          // orgid: orgId,
          // jobid: courseId,
          objid: sessionStorage.getItem("dow_id"),
          email: sessionStorage.getItem("email"),
        }
      );
      console.log(res.data, "xxx1");
      if (res.data) {
        setDownloadingModal(false);
      }
      // var blob = new Blob([res.data], { type: ".csv" });
      // fileSaver.saveAs(blob, "allCandidates.csv");
      Swal.fire({
        text: "File will be  mailed shortly to registered email Id (ETA 2 Minutes)",
      });
    } catch (err) {
      console.log(err);
    }
  };

  // const mainTable = [];
  // for (let i = 0; i < 20; i++) {
  //   mainTable.push({
  //     key: i + 1,
  //     candidate: i % 2 === 0 ? "Ramesh" : i % 3 === 0 ? "Suresh" : "Rajesh",
  //     mobile: "8885558888",
  //     education: i % 2 === 0 ? "Graduacte" : i % 3 === 0 ? "HSC" : "SSC",
  //     role: i % 2 === 0 ? "Full Stack" : i % 3 === 0 ? "Carpenter" : "Android Developer",
  //     state: i % 2 === 0 ? "Maharashtra" : i % 3 === 0 ? "Delhi" : "Gujrat",
  //     district: i % 2 === 0 ? "Mumbai" : i % 3 === 0 ? "Delhi" : "Surat",
  //     skills: "Cartpenter, welding",
  //     score: `80`,
  //     status: i % 2 === 0 ? "true" : i % 3 === 0 ? "false" : "",
  //   });
  // }
  const [downloadingModal, setDownloadingModal] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [admindata, Setadmindata] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedCSVData, setSelectedCSVData] = useState([]);
  const [tablerow, setTablerow] = useState([]);
  const [fileName, setFileName] = useState("");
  const [paginationState, setPaginationState] = useState({
    page: 1,
    dataSize: "",
  });
  const [show, setShow] = useState(false);
  const fetchCandidates = async () => {
    setIsLoading(true);
    await axios
      // .get(
      //   `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/details`,
      //   {
      //     params: {
      //       cp_id: cpId,
      //       orgid: orgId,
      //       jobid: courseId,
      //       limit: pageSize,
      //       offset: paginationState.page - 1,
      //     },
      //   }
      // )
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/crm/${courseId}/fetch-learners`, {
        params: {
          search: 0,
          batch_id: batchId,
        },
      })
      .then((res) => {
        console.log(res.data, "js_data");
        sessionStorage.setItem("dow_id", res.data.download_id);
        res.data.length === 0
          ? setSearchData([])
          : setSearchData(
              res.data?.map((ele, id) => ({
                key: ele.candid,
                candid: ele.candid,
                created_date:
                  ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                    ? ""
                    : moment(ele.createddt).format("DD-MM-YYYY"),
                first_name: ele.firstname,
                last_name: ele.lastname,
                candidate: `${ele.firstname} ${ele.lastname}`,
                date_of_birth: ele.date_of_birth
                  ? moment(ele.date_of_birth).format("DD-MM-YYYY")
                  : "",
                mobile: ele.mobnum?.length === 12 ? ele.mobnum?.substring(2) : ele.mobnum,
                email:
                  ele.email === "nan" || ele.email === null || ele.email === "" ? "" : ele.email,
                gender:
                  ele.gender === "nan" || ele.gender === "" || ele.gender === null
                    ? ""
                    : ele.gender,
                state:
                  ele.state === "nan" || ele.state === "" || ele.state === null ? "" : ele.state,
                district:
                  ele.district === "nan" || ele.district === "" || ele.district === null
                    ? ""
                    : ele.district,
                taluka:
                  ele.taluka === "nan" || ele.taluka === "" || ele.taluka === null
                    ? ""
                    : ele.taluka,
                highest_education:
                  ele.highest_education === "nan" ||
                  ele.highest_education === "" ||
                  ele.highest_education === null
                    ? ""
                    : ele.highest_education,
                degree:
                  ele.degree === "nan" || ele.degree === "" || ele.degree === null
                    ? ""
                    : ele.degree,
                stream:
                  ele.stream === "nan" || ele.stream === "" || ele.stream === null
                    ? ""
                    : ele.stream,
                experience:
                  ele.experience === "nan" || ele.experience === "" || ele.experience === null
                    ? ""
                    : ele.experience,
                current_salary:
                  ele.current_salary === "nan" ||
                  ele.current_salary === "" ||
                  ele.current_salary === null
                    ? ""
                    : ele.current_salary,
                desired_salary:
                  ele.desired_salary === "nan" ||
                  ele.desired_salary === "" ||
                  ele.desired_salary === null
                    ? ""
                    : ele.desired_salary,
                job_role:
                  ele.job_role === "nan" || ele.job_role === "" || ele.job_role === null
                    ? ""
                    : ele.job_role,
                industry:
                  ele.industry === "nan" || ele.industry === "" || ele.industry === null
                    ? ""
                    : ele.industry,
                marital_status:
                  ele.marital_status === "nan" ||
                  ele.marital_status === "" ||
                  ele.marital_status === null
                    ? ""
                    : ele.marital_status,
                skills:
                  ele.skills === "nan" || ele.skills === "" || ele.skills === null
                    ? ""
                    : ele.skills,
                part_time: ele.part_time,
                specially_abled: ele.specially_abled,
                job_priority: ele.job_priority,
                resume_cv:
                  ele.resume_cv === "nan" || ele.resume_cv === "" || ele.resume_cv === null
                    ? ""
                    : ele.resume_cv,
                last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
                last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
                data_status_type: ele.data_status_type,
                wa_optin: ele.wa_optin,
                datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
                createddt: moment(ele.createddt).format("DD-MM-YYYY"),
                modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
                languages:
                  ele.languages === "nan" || ele.languages === "" || ele.languages === null
                    ? ""
                    : ele.languages,
                age: ele.age,
                ///////// stages data////////
                feedback:
                  ele.feedback === "nan" || ele.feedback === "" || ele.feedback === null
                    ? ""
                    : ele.feedback,
                sent_status: ele.sent_status,
                broadcast_status: ele.broadcast_status,
                ratings: ele.ratings,
                // stage: ele.stage,
                // completion_status: ele.completion_status,
                // candidate_status: ele.candidate_status,
                stage: ele.stage ? ele.stage : 0,
                completion_status: ele.completion_status ? ele.completion_status : "in_progress",
                candidate_status: ele.status ? ele.status : "Interested",
                display_comment:
                  ele.display_comment === "" ||
                  ele.display_comment === "nan" ||
                  ele.display_comment === null
                    ? ""
                    : ele.display_comment,
                batch_name: ele.batch_name !== "" ? ele.batch_name : " - ",
              }))
            );
        Setadmindata(
          res.data?.map((ele, id) => ({
            key: ele.candid,
            candid: ele.candid,
            created_date:
              ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                ? ""
                : moment(ele.createddt).format("DD-MM-YYYY"),
            first_name: ele.firstname,
            last_name: ele.lastname,
            candidate: `${ele.firstname} ${ele.lastname}`,
            date_of_birth: ele.date_of_birth ? moment(ele.date_of_birth).format("DD-MM-YYYY") : "",
            mobile: ele.mobnum?.length === 12 ? ele.mobnum?.substring(2) : ele.mobnum,
            email: ele.email === "nan" || ele.email === null || ele.email === "" ? "" : ele.email,
            gender:
              ele.gender === "nan" || ele.gender === "" || ele.gender === null ? "" : ele.gender,
            state: ele.state === "nan" || ele.state === "" || ele.state === null ? "" : ele.state,
            district:
              ele.district === "nan" || ele.district === "" || ele.district === null
                ? ""
                : ele.district,
            taluka:
              ele.taluka === "nan" || ele.taluka === "" || ele.taluka === null ? "" : ele.taluka,
            highest_education:
              ele.highest_education === "nan" ||
              ele.highest_education === "" ||
              ele.highest_education === null
                ? ""
                : ele.highest_education,
            degree:
              ele.degree === "nan" || ele.degree === "" || ele.degree === null ? "" : ele.degree,
            stream:
              ele.stream === "nan" || ele.stream === "" || ele.stream === null ? "" : ele.stream,
            experience:
              ele.experience === "nan" || ele.experience === "" || ele.experience === null
                ? ""
                : ele.experience,
            current_salary:
              ele.current_salary === "nan" ||
              ele.current_salary === "" ||
              ele.current_salary === null
                ? ""
                : ele.current_salary,
            desired_salary:
              ele.desired_salary === "nan" ||
              ele.desired_salary === "" ||
              ele.desired_salary === null
                ? ""
                : ele.desired_salary,
            job_role:
              ele.job_role === "nan" || ele.job_role === "" || ele.job_role === null
                ? ""
                : ele.job_role,
            industry:
              ele.industry === "nan" || ele.industry === "" || ele.industry === null
                ? ""
                : ele.industry,
            marital_status:
              ele.marital_status === "nan" ||
              ele.marital_status === "" ||
              ele.marital_status === null
                ? ""
                : ele.marital_status,
            skills:
              ele.skills === "nan" || ele.skills === "" || ele.skills === null ? "" : ele.skills,
            part_time: ele.part_time,
            specially_abled: ele.specially_abled,
            job_priority: ele.job_priority,
            resume_cv:
              ele.resume_cv === "nan" || ele.resume_cv === "" || ele.resume_cv === null
                ? ""
                : ele.resume_cv,
            last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
            last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
            data_status_type: ele.data_status_type,
            wa_optin: ele.wa_optin,
            datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
            createddt: moment(ele.createddt).format("DD-MM-YYYY"),
            modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
            languages:
              ele.languages === "nan" || ele.languages === "" || ele.languages === null
                ? ""
                : ele.languages,
            age: ele.age,
            ///////// stages data////////
            feedback:
              ele.feedback === "nan" || ele.feedback === "" || ele.feedback === null
                ? ""
                : ele.feedback,
            sent_status: ele.sent_status,
            broadcast_status: ele.broadcast_status,
            ratings: ele.ratings,
            // stage: ele.stage,
            // completion_status: ele.completion_status,
            // candidate_status: ele.candidate_status,
            stage: ele.stage ? ele.stage : 0,
            completion_status: ele.completion_status ? ele.completion_status : "in_progress",
            candidate_status: ele.status ? ele.status : "Interested",
            display_comment:
              ele.display_comment === "" ||
              ele.display_comment === "nan" ||
              ele.display_comment === null
                ? ""
                : ele.display_comment,
            batch_name: ele.batch_name !== "" ? ele.batch_name : " - ",
          }))
        );
        setPaginationState({ ...paginationState, dataSize: res.data["count"] });
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("err candidate", err.response);
        setIsLoading(false);
        // setSearchData([
        //   {
        //     key: 1,
        //     created_date: "07-06-2024",
        //     candidate: "XYZ",
        //     mobile: "",
        //     email: "",
        //     gender: "",
        //     state: "",
        //     district: "",
        //     candidate_status: "First Call",
        //   },
        //   {
        //     key: 2,
        //     created_date: "07-06-2024",
        //     candidate: "ABC",
        //     mobile: "",
        //     email: "",
        //     gender: "",
        //     state: "",
        //     district: "",
        //     candidate_status: "Not Answering",
        //   },
        // ]);
      });
  };
  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys.toString());
    setSelectedRowKeys(newSelectedRowKeys);
    filterData(admindata, newSelectedRowKeys);
    setTablerow(selectedRows);
    // setShortlistObj(
    //   selectedRows.reduce(
    //     (obj, item) =>
    //       Object.assign(obj, { [item.key]: item.score === undefined ? 0 : item.score }),
    //     {}
    //   )
    // );
  };
  const filterData = (data, keyId) => {
    const newData = data.filter((item, id) => {
      // return item.key!==keyId
      // i => ids.includes( i.empid )
      return keyId.includes(item.key);
    });
    console.log(newData);
    setSelectedCSVData(newData);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
  };
  const handlePageSizeChange = (current, size) => {
    console.log("Selected page size:", size);
    setPageSize(size);
  };
  console.log("selected data", selectedCSVData);

  const getFileName = () => {
    let d = new Date();
    let dformat = `${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`;

    console.log("getCurrentDate : ", dformat);
    const file = "candidate_data" + ".csv";
    setFileName(file);
    // return "mis_data_" + dformat + ".txt";
  };

  const handleFormChange12 = (event, index, state, setState) => {
    let data = [...state];
    console.log(index);
    console.log(event);
    data[index]["isExportable"] = !data[index]["isExportable"];
    // data[index][event] = event.value;
    setState(data);
  };

  const bulkUploadfunc = () => {
    setLoading(true);
    Swal.fire({
      //icon: "success",
      title: "Uploading",
      text: "File upload is in progress",
      showConfirmButton: false,
      timer: 3000,
    });
    let formData = new FormData();
    formData.append("jobseeker_file", CSVFile);
    formData.append("datasource", cpId);
    // formData.append("jobid", objectOfLinks.courseId);
    // formData.append("orgid", objectOfLinks.orgid);
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/upload`,
        formData
      )
      .then((res) => {
        setLoading(false);
        if (res.status === 201) {
          /*
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "File Uploaded successfully",
            showConfirmButton: false,
            timer: 3000,
          });
          */

          Swal.fire({
            icon: "success",
            // title: "Success",
            // text: "File Uploaded successfully",
            title: "File Uploaded Successfully",
            html:
              "Successfully Uploaded: " +
              `${res.data["Success"]}` +
              "<br/>" +
              "Failed In Uploading: " +
              `${res.data["On Hold"]}` +
              "<br/>" +
              "Data Already Existing With Us: " +
              `${res.data["Duplicates"]}`,
            showConfirmButton: res?.data?.link !== "" ? true : false,
            confirmButtonText: "Data Quality Issue",
            // timer: 3000,
          }).then((result) => {
            if (result.isConfirmed) {
              if (res?.data?.link !== "") {
                //var blob = new Blob([res.data.link], { type: ".csv" });
                //fileSaver.saveAs(blob, "download.csv");
                const link = document.createElement("a");
                link.href = res?.data?.link;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else {
                console.log("error");
              }
            }
          });

          // setactionModal2(false);
          setUploadModal(false);
          setUploadOption(false);
          // setShowSnackbar(false);
          // UploadedList();
          // setUploadModal(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: err.response.data["Developer Message"]
            ? err.response.data["Developer Message"]
            : "Oops...",
          text: err.response.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };

  console.log(filteroff, "BBB");

  const fetchFilteredCandidates = async () => {
    setIsLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/filter`,
        {
          jobid: courseId,
          cpid: cpId,
          date: filteroff ? [] : datefilter ? datefilter : [],
          state: filteroff ? "" : statefilter ? statefilter : "",
          district: filteroff ? "" : districtfilter ? districtfilter : "",
          status: filteroff ? "" : jffilter ? jffilter : "",
          gender: filteroff ? "" : rolefilter ? rolefilter : "",
          // age: filteroff ? "" : boardingfilter ? boardingfilter : "",
          age: "",
          limit: pageSize,
          offset: paginationState.page - 1,
        }
      )
      .then((res) => {
        console.log("res", res);
        sessionStorage.setItem("dow_id", res.data.download_id);
        setIsLoading(false);
        setSearchData(
          res.data["filter_data"]?.map((ele, id) => ({
            key: ele.registration_id,
            registration_id: ele.registration_id,
            created_date:
              ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                ? ""
                : moment(ele.createddt).format("DD-MM-YYYY"),
            first_name: ele.first_name,
            last_name: ele.last_name,
            candidate: `${ele.first_name} ${ele.last_name}`,
            date_of_birth: ele.date_of_birth ? moment(ele.date_of_birth).format("DD-MM-YYYY") : "",
            mobile: ele.mobile?.length === 12 ? ele.mobile?.substring(2) : ele.mobile,
            email: ele.email === "nan" || ele.email === null || ele.email === "" ? "" : ele.email,
            gender:
              ele.gender === "nan" || ele.gender === "" || ele.gender === null ? "" : ele.gender,
            state: ele.state === "nan" || ele.state === "" || ele.state === null ? "" : ele.state,
            district:
              ele.district === "nan" || ele.district === "" || ele.district === null
                ? ""
                : ele.district,
            taluka:
              ele.taluka === "nan" || ele.taluka === "" || ele.taluka === null ? "" : ele.taluka,
            highest_education:
              ele.highest_education === "nan" ||
              ele.highest_education === "" ||
              ele.highest_education === null
                ? ""
                : ele.highest_education,
            degree:
              ele.degree === "nan" || ele.degree === "" || ele.degree === null ? "" : ele.degree,
            stream:
              ele.stream === "nan" || ele.stream === "" || ele.stream === null ? "" : ele.stream,
            experience:
              ele.experience === "nan" || ele.experience === "" || ele.experience === null
                ? ""
                : ele.experience,
            current_salary:
              ele.current_salary === "nan" ||
              ele.current_salary === "" ||
              ele.current_salary === null
                ? ""
                : ele.current_salary,
            desired_salary:
              ele.desired_salary === "nan" ||
              ele.desired_salary === "" ||
              ele.desired_salary === null
                ? ""
                : ele.desired_salary,
            job_role:
              ele.job_role === "nan" || ele.job_role === "" || ele.job_role === null
                ? ""
                : ele.job_role,
            industry:
              ele.industry === "nan" || ele.industry === "" || ele.industry === null
                ? ""
                : ele.industry,
            marital_status:
              ele.marital_status === "nan" ||
              ele.marital_status === "" ||
              ele.marital_status === null
                ? ""
                : ele.marital_status,
            skills:
              ele.skills === "nan" || ele.skills === "" || ele.skills === null ? "" : ele.skills,
            part_time: ele.part_time,
            specially_abled: ele.specially_abled,
            job_priority: ele.job_priority,
            resume_cv:
              ele.resume_cv === "nan" || ele.resume_cv === "" || ele.resume_cv === null
                ? ""
                : ele.resume_cv,
            last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
            last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
            data_status_type: ele.data_status_type,
            wa_optin: ele.wa_optin,
            datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
            createddt: moment(ele.createddt).format("DD-MM-YYYY"),
            modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
            languages:
              ele.languages === "nan" || ele.languages === "" || ele.languages === null
                ? ""
                : ele.languages,
            age: ele.age,
            ///////// stages data////////
            feedback:
              ele.feedback === "nan" || ele.feedback === "" || ele.feedback === null
                ? ""
                : ele.feedback,
            sent_status: ele.sent_status,
            broadcast_status: ele.broadcast_status,
            ratings: ele.ratings,
            // stage: ele.stage,
            // completion_status: ele.completion_status,
            // candidate_status: ele.candidate_status,
            stage: ele.stage ? ele.stage : 0,
            completion_status: ele.completion_status ? ele.completion_status : "in_progress",
            candidate_status: ele.status ? ele.status : "Interested",
            display_comment:
              ele.display_comment === "nan" ||
              ele.display_comment === "" ||
              ele.display_comment === null
                ? ""
                : ele.display_comment,
          }))
        );
        Setadmindata(
          res.data["filter_data"]?.map((ele, id) => ({
            key: ele.registration_id,
            registration_id: ele.registration_id,
            created_date:
              ele.createddt === "" || ele.createddt === "nan" || ele.createddt === null
                ? ""
                : moment(ele.createddt).format("DD-MM-YYYY"),
            first_name: ele.first_name,
            last_name: ele.last_name,
            candidate: `${ele.first_name} ${ele.last_name}`,
            date_of_birth: ele.date_of_birth ? moment(ele.date_of_birth).format("DD-MM-YYYY") : "",
            mobile: ele.mobile?.length === 12 ? ele.mobile?.substring(2) : ele.mobile,
            email: ele.email === "nan" ? "" : ele.email,
            gender: ele.gender === "nan" ? "" : ele.gender,
            state: ele.state === "nan" ? "" : ele.state,
            district: ele.district === "nan" ? "" : ele.district,
            taluka: ele.taluka === "nan" ? "" : ele.taluka,
            highest_education: ele.highest_education === "nan" ? "" : ele.highest_education,
            degree: ele.degree === "nan" ? "" : ele.degree,
            stream: ele.stream === "nan" ? "" : ele.stream,
            experience: ele.experience === "nan" ? "" : ele.experience,
            current_salary: ele.current_salary === "nan" ? "" : ele.current_salary,
            desired_salary: ele.desired_salary === "nan" ? "" : ele.desired_salary,
            job_role: ele.job_role === "nan" ? "" : ele.job_role,
            industry: ele.industry === "nan" ? "" : ele.industry,
            marital_status: ele.marital_status === "nan" ? "" : ele.marital_status,
            skills: ele.skills === "nan" ? "" : ele.skills,
            part_time: ele.part_time,
            specially_abled: ele.specially_abled,
            job_priority: ele.job_priority,
            resume_cv: ele.resume_cv === "nan" ? "" : ele.resume_cv,
            last_activedate: moment(ele.last_activedate).format("DD-MM-YYYY"),
            last_activetime: moment(ele.last_activetime).format("DD-MM-YYYY"),
            data_status_type: ele.data_status_type,
            wa_optin: ele.wa_optin,
            datasource: ele.digital_volunteer ? ele.digital_volunteer : ele.datasource,
            createddt: moment(ele.createddt).format("DD-MM-YYYY"),
            modifieddt: moment(ele.modifieddt).format("DD-MM-YYYY"),
            languages: ele.languages === "nan" ? "" : ele.languages,
            age: ele.age,
            ///////// stages data////////
            feedback:
              ele.feedback === "nan" || ele.feedback === "" || ele.feedback === null
                ? ""
                : ele.feedback,
            sent_status: ele.sent_status,
            broadcast_status: ele.broadcast_status,
            ratings: ele.ratings,
            // stage: ele.stage,
            // completion_status: ele.completion_status,
            // candidate_status: ele.candidate_status,
            stage: ele.stage ? ele.stage : 0,
            completion_status: ele.completion_status ? ele.completion_status : "in_progress",
            candidate_status: ele.status ? ele.status : "Interested",
            display_comment:
              ele.display_comment === "nan" ||
              ele.display_comment === "" ||
              ele.display_comment === null
                ? ""
                : ele.display_comment,
          }))
        );
        setPaginationState({ ...paginationState, dataSize: res.data["count"] });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const HandleBulkUpload = async () => {
    let bulkData = new FormData();
    bulkData.append("course_id", courseId);
    bulkData.append("batch_id", batchId);
    bulkData.append("file", CSVFile1);
    bulkData.append("uploaded_by", cpId);
    bulkData.append("stage", stageSelect.value);
    if (CSVFile1 === "") {
      Swal.fire({
        icon: "info",
        title: "Please upload file",
        //text: err?.data["User Message"],
        showConfirmButton: false,
        timer: 3000,
      });
    } else {
      const waitingPopup = Swal.fire({
        title: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios
        .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/upload-candidate`, bulkData)
        .then((res) => {
          console.log(res.data);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          Swal.fire({
            icon: "success",
            // title: "Success",
            text: "File Uploaded successfully",
            // title: res.data.message !== "" ? res.data.message : "File Uploaded Successfully",
            // showConfirmButton: true,
            // showConfirmButton: res?.data?.link !== "" ? true : false,
            timer: 3000,
          });
          setCSVFile1("");
          setRefFile1("");
          setUploadModal(false);
          // fetchAllRefereeDataAPI();
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          console.log("error ", err);
          Swal.fire({
            icon: "error",
            title: err?.response?.data["Developer Message"]
              ? err?.response?.data["Developer Message"]
              : "Something went wrong",
            //text: err?.data["User Message"],
            showConfirmButton: false,
            timer: 3000,
          });
        });
    }
  };

  const MoveCandidatesFunc = async () => {
    const waitingPopup = Swal.fire({
      title: "Please wait...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    await axios
      .post(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/assign-batch`, {
        candid: selectedRowKeys.toString(),
        course_id: courseId,
        batch_id: batchId,
        stage: tableshow === 0 ? 0 : tableshow === 1 ? 1 : 3,
      })
      .then((res) => {
        console.log(res.data);
        setTimeout(() => {
          waitingPopup.close(); // to close swal
        }, 0);
        Swal.fire({
          icon: "success",
          // title: "Success",
          text: "Candidates Moved Successfully",
          // title: res.data.message !== "" ? res.data.message : "File Uploaded Successfully",
          // showConfirmButton: true,
          // showConfirmButton: res?.data?.link !== "" ? true : false,
          timer: 3000,
        }).then((res) => {
          tableshow === 0
            ? fetchCandidates()
            : tableshow === 1
            ? fetchTable1()
            : tableshow === 2
            ? fetchTable2()
            : fetchTable3();
        });
        // setCSVFile1("");
        // setRefFile1("");
        // setUploadModal(false);
        // fetchAllRefereeDataAPI();
      })
      .catch((err) => {
        console.log(err);
        setTimeout(() => {
          waitingPopup.close(); // to close swal
        }, 0);
        console.log("error ", err);
        Swal.fire({
          icon: "error",
          title: err?.response?.data["Developer Message"]
            ? err?.response?.data["Developer Message"]
            : "Something went wrong",
          //text: err?.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };
  const UpdateStatusFunc = async (type) => {
    const waitingPopup = Swal.fire({
      title: "Please wait...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    await axios
      .patch(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/update-candidate-status`,
        type === 0
          ? {
              candid: selectedRowKeys,
              course_id: courseId,
              batch_id: batchId,
              attendance_status: statusValue,
              // type===0 && test_status: statusValue,
              // type===0 &&ojt_status: statusValue,
              // type===0 && attendence_status: statusValue,
              // type===0 &&placement_status: statusValue,
            }
          : type === 1
          ? {
              candid: selectedRowKeys,
              course_id: courseId,
              batch_id: batchId,
              test_status: statusValue,
            }
          : type === 2
          ? {
              candid: selectedRowKeys,
              course_id: courseId,
              batch_id: batchId,
              ojt_status: statusValue,
            }
          : type == 3
          ? {
              candid: selectedRowKeys,
              course_id: courseId,
              batch_id: batchId,
              placed: statusValue == "Yes" ? 1 : 0,
            }
          : {
              candid: selectedRowKeys,
              course_id: courseId,
              batch_id: batchId,
              self_employed: statusValue == "Yes" ? "Yes" : "No",
            }
      )
      .then((res) => {
        console.log(res.data);
        setTimeout(() => {
          waitingPopup.close(); // to close swal
        }, 0);
        Swal.fire({
          icon: "success",
          // title: "Success",
          text: "Status Updated Successfully",
          // title: res.data.message !== "" ? res.data.message : "Status Updated Successfully",
          // showConfirmButton: true,
          // showConfirmButton: res?.data?.link !== "" ? true : false,
          timer: 3000,
        }).then((res) => {
          fetchTable2();
          setStatusModal(false);
          setStatusValue("");
          setStatusType(0);
        });
        // setCSVFile1("");
        // setRefFile1("");
        // setUploadModal(false);
        // fetchAllRefereeDataAPI();
      })
      .catch((err) => {
        console.log(err);
        setTimeout(() => {
          waitingPopup.close(); // to close swal
        }, 0);
        console.log("error ", err);
        Swal.fire({
          icon: "error",
          title: err?.response?.data["Developer Message"]
            ? err?.response?.data["Developer Message"]
            : "Something went wrong",
          //text: err?.data["User Message"],
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };
  const fetchAttdFunc = async (candid) => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/fetch-attendance`, {
        params: { candid: candid },
      })
      .then((res) => {
        console.log("attd table", res.data);
        setAttdTable(res.data);
      })
      .catch((err) => {
        console.log(err);

        console.log("error ", err);
        // Swal.fire({
        //   icon: "error",
        //   title: err?.response?.data["Developer Message"]
        //     ? err?.response?.data["Developer Message"]
        //     : "Something went wrong",
        //   //text: err?.data["User Message"],
        //   showConfirmButton: false,
        //   timer: 3000,
        // });
      });
  };

  const HandleUploadMedia = async (el) => {
    console.log(refFile2, "ref22", CSVFile2);
    let bulkData = new FormData();
    bulkData.append("candid", batchDetail.candid);
    bulkData.append("batch_id", batchDetail.batch_id);
    bulkData.append("type", stageName === "" ? "pre-session" : stageName);
    bulkData.append("mediafile", el);
    // bulkData.append("media", CSVFile2);
    // bulkData.append("uploaded_by", sessionStorage.getItem("register_id"));
    if (CSVFile2 === "" && refFile2 === "") {
      Swal.fire({
        icon: "info",
        title: "Please upload files or provide drive link",
        //text: err?.data["User Message"],
        showConfirmButton: false,
        timer: 3000,
      });
    } else {
      const waitingPopup = Swal.fire({
        title: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios
        .post(
          `${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/candidate-media-upload`,
          bulkData
        )
        .then((res) => {
          console.log(res.data);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          Swal.fire({
            icon: "success",
            // title: "Success",
            text: "Feedback Video Uploaded Successfully",
            // title: res.data.message !== "" ? res.data.message : "Media Uploaded Successfully",
            // showConfirmButton: true,
            // showConfirmButton: res?.data?.link !== "" ? true : false,
            timer: 3000,
          });
          setCSVFile2("");
          setRefFile2("");
          setUploadMedia(false);
          setStageName("");
          fetchTable2();
          // HandleViewBatches(batchDetail.course_id);
          // fetchAllRefereeDataAPI();
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          console.log("error ", err);
          Swal.fire({
            icon: "error",
            title: err?.response?.data["Developer Message"]
              ? err?.response?.data["Developer Message"]
              : "Something went wrong",
            //text: err?.data["User Message"],
            showConfirmButton: false,
            timer: 3000,
          });
        });
    }
  };

  const HandleUploadMediaLink = async () => {
    console.log(refFile2, "ref22", CSVFile2);
    let bulkData = new FormData();
    bulkData.append("candid", batchDetail.candid);
    bulkData.append("batch_id", batchDetail.batch_id);
    bulkData.append("type", stageName === "" ? "pre-session" : stageName);
    bulkData.append("mediaurl", CSVFile2);
    // bulkData.append("uploaded_by", sessionStorage.getItem("register_id"));
    if (CSVFile2 === "" && refFile2 === "") {
      Swal.fire({
        icon: "info",
        title: "Please upload files or provide drive link",
        //text: err?.data["User Message"],
        showConfirmButton: false,
        timer: 3000,
      });
    } else {
      const waitingPopup = Swal.fire({
        title: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios
        .post(
          `${process.env.REACT_APP_BACKEND_GENERIC_URL}/skilling/candidate-media-upload`,
          bulkData
        )
        .then((res) => {
          console.log(res.data);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          Swal.fire({
            icon: "success",
            // title: "Success",
            text: "Feedback Video Uploaded Successfully",
            // title: res.data.message !== "" ? res.data.message : "Media Uploaded Successfully",
            // showConfirmButton: true,
            // showConfirmButton: res?.data?.link !== "" ? true : false,
            timer: 3000,
          });
          setCSVFile2("");
          setRefFile2("");
          setUploadMedia(false);
          fetchTable2();
          setStageName("");
          // fetchAllRefereeDataAPI();
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            waitingPopup.close(); // to close swal
          }, 0);
          console.log("error ", err);
          Swal.fire({
            icon: "error",
            title: err?.response?.data["Developer Message"]
              ? err?.response?.data["Developer Message"]
              : "Something went wrong",
            //text: err?.data["User Message"],
            showConfirmButton: false,
            timer: 3000,
          });
        });
    }
  };

  const HandleUploadMediaLoop = async () => {
    if (CSVFile2 === "" && refFile2 === "") {
      Swal.fire({
        icon: "info",
        title: "Please upload files or provide drive link",
        //text: err?.data["User Message"],
        showConfirmButton: false,
        timer: 3000,
      });
    } else {
      if (refFile2 !== "") {
        HandleUploadMedia(refFile2);
      } else {
        HandleUploadMediaLink();
      }
    }
  };

  useEffect(() => {
    // handleFetchjob();
  }, [orgId]);
  useEffect(() => {
    // handleFetchorg();
    // fetchCandidates();
    handleFetchjob();
    handleKPIs();
    searchParams.get("show") === null && setSearchParams({ show: "interested" });
  }, []);
  useEffect(() => {
    courseId !== "" && handleKPIs();
    handleFetchBatches();
  }, [courseId]);
  useEffect(() => {
    (courseId !== "" || batchId !== "") && tableshow === 0 && fetchCandidates();
    (courseId !== "" || batchId !== "") && tableshow === 1 && fetchTable1();
    (courseId !== "" || batchId !== "") && tableshow === 2 && fetchTable2();
    (courseId !== "" || batchId !== "") && tableshow === 3 && fetchTable3();
  }, [courseId, batchId]);

  // useEffect(() => {
  //   // fetchFilteredCandidates();
  //   datefilter.length === 0 &&
  //     statefilter === "" &&
  //     districtfilter === "" &&
  //     jffilter === "" &&
  //     rolefilter === "" &&
  //     name === "" &&
  //     !filteroff &&
  //     fetchCandidates();
  // }, [paginationState.page, pageSize]);

  useEffect(() => {
    if (name !== "") {
      const DebounceFunc = setTimeout(() => {
        handleDynamicSearch();
      }, 1000);

      return () => clearTimeout(DebounceFunc);
    } else {
      !filteroff && name === "" && fetchCandidates();
    }
  }, [name]);

  useEffect(() => {
    if (
      datefilter.length === 0 &&
      statefilter === "" &&
      districtfilter === "" &&
      jffilter === "" &&
      rolefilter === "" &&
      name !== ""
    ) {
      handleDynamicSearch();
    } else if (
      datefilter.length !== 0 &&
      statefilter !== "" &&
      districtfilter !== "" &&
      jffilter !== "" &&
      rolefilter !== "" &&
      name !== ""
    ) {
      handleDynamicSearch();
    } else if (name !== "") {
      handleDynamicSearch();
    }
    // else {
    //   fetchFilteredCandidates();
    // }
  }, [paginationState.page, pageSize]);
  useEffect(() => {
    (datefilter.length !== 0 ||
      statefilter !== "" ||
      districtfilter !== "" ||
      jffilter !== "" ||
      rolefilter !== "") &&
      name === "" &&
      fetchFilteredCandidates();
    // showFilter === false && fetchFilteredCandidates();
  }, [paginationState.page, pageSize, filteroff]);

  const resetfunc = () => {
    setFilteroff(true);
    setBoardingfilter([18, 45]);
    setRolefilter("");
    setStatefilter("");
    setDistrictfilter("");
    setJffilter("");
    setDatefilter([]);
    tableshow === 1 && fetchTable1();
    tableshow === 2 && fetchTable2();
    tableshow === 0 && fetchCandidates();
  };

  const setFunc = () => {
    setFilteroff(false);
  };

  // useEffect(() => {
  //   (datefilter.length !== 0 ||
  //     statefilter !== "" ||
  //     districtfilter !== "" ||
  //     jffilter !== "" ||
  //     rolefilter !== "") &&
  //     fetchFilteredCandidates();
  // }, [filteroff]);

  console.log("showparams", searchParams.get("show"));

  return (
    <>
      <DashboardLayout>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            <img
              src={imga6}
              height={"30px"}
              style={{ marginTop: "8px", marginBottom: "8px" }}
              alt=""
            />

            <Box sx={{ m: 1 }}>
              <ST3 variant="body1">Candidates for</ST3>
            </Box>

            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              {/* <Box sx={{ m: 1, minWidth: "230px" }}>
                <ST4 variant="body1">Select Skill Provider</ST4>

                <Select
                  isClearable
                  options={orgList}
                  value={orgList.filter((ele) => orgId === ele.value)}
                  onChange={(e) => setOrgId(e ? e.value : "")}
                  styles={stylesDD}
                />
              </Box> */}

              <Box sx={{ m: 1, minWidth: "230px" }}>
                <ST4 variant="body1">Select Course</ST4>

                <Select
                  isClearable
                  placeholder="Select Course"
                  options={jobList}
                  value={jobList?.filter((ele) => courseId === ele.value)}
                  onChange={(e) => setCourseId(e ? e.value : "")}
                  styles={stylesDD}
                />
              </Box>
              <Box sx={{ m: 1, minWidth: "230px" }}>
                <ST4 variant="body1">Select Batch</ST4>

                <Select
                  isClearable
                  placeholder="Select Batch"
                  options={batchList}
                  value={batchList?.filter((ele) => batchId == ele.value)}
                  onChange={(e) => setBatchId(e ? e.value : "")}
                  styles={stylesDD}
                />
              </Box>
            </Box>
          </Box>

          <SoftBox
            sx={{
              height: "34px",
              backgroundColor: "#FFF",
              borderRadius: "2px",
              cursor: "pointer",
              p: 1,
            }}
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="40px"
            onClick={() => (handleFetchorg(), handleKPIs(), resetfunc())}
          >
            <SoftBox>
              <img src={refreshBtn} />
            </SoftBox>
          </SoftBox>
        </Box>
        {/* <br /> */}
        {/* <Grid container spacing={2}>
          {loading ? (
            <>
              {Array.from(Array(4).keys()).map((v, i) => {
                return (
                  <Grid item lg={4} sm={12} md={6} xs={12} key={i}>
                    <SBox1>
                      <SBox2>
                        <SVerticalBox>&nbsp;</SVerticalBox>

                        <SBox3>
                          <Box>
                            <Skeleton
                              variant="rounded"
                              animation="wave"
                              sx={{ height: "16px", width: "120px", m: 0.5, mb: 1.8 }}
                            />

                            <Skeleton
                              variant="rounded"
                              animation="wave"
                              sx={{ height: "24px", width: "90px", m: 0.5, mb: 1.4 }}
                            />

                            <SBox4>
                              <Skeleton
                                variant="rounded"
                                animation="wave"
                                sx={{
                                  height: "30px",
                                  width: "140px",
                                  background: "rgba(112, 186, 191, 0.17)",
                                  borderRadius: "7px",
                                }}
                              />
                            </SBox4>
                          </Box>
                        </SBox3>
                      </SBox2>
                    </SBox1>
                  </Grid>
                );
              })}
            </>
          ) : (
            <>
              {kpiArr.map((v, i) => {
                return (
                  <Grid item lg={3} sm={12} md={6} xs={12} key={i}>
                    <SBox1 onClick={() => navigate(v.url)} sx={{ cursor: "pointer" }}>
                      <SBox2>
                        <SVerticalBox>&nbsp;</SVerticalBox>

                        <SBox3>
                          <Box>
                            <SKPIHeading>
                              {v.heading} <img src={info} height={"15px"} width={"15px"} />
                            </SKPIHeading>

                            <SKPICount>{v.count1}</SKPICount>

                            <Box
                              sx={{
                                p: 0.65,
                                m: 0.5,
                                background: "rgba(112, 186, 191, 0.17)",
                                borderRadius: "7px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexWrap: "wrap",
                              }}
                            >
                              <SKPISubHeading1> {v.subheading}</SKPISubHeading1>

                              <SKPISubHeading2>{v.count2}</SKPISubHeading2>
                            </Box>
                          </Box>
                        </SBox3>
                      </SBox2>
                    </SBox1>
                  </Grid>
                );
              })}
            </>
          )}
        </Grid> */}
        <br />
        {/*<hr /> */}

        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            mb: 2,
          }}
        >
          <SoftBox
            sx={{
              border: "1px solid #000",
              borderRadius: "5px",
              borderTopRightRadius: "0px",
              borderBottomRightRadius: "0px",
              width: "125px",
              height: "45px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              p: 1,
              textAlign: "center",
              backgroundColor: tableshow === 0 ? "#3B5092" : "#fff",
            }}
            onClick={() => {
              setTableshow(0);
              setSearchParams({ show: "interested" });
            }}
          >
            <SoftTypography
              sx={
                tableshow === 0
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // color: "#1B59F8",
                      color: "#fff",
                      fontSize: "16px",
                    }
                  : {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // color: "#000",
                      color: "#3B5092",
                      fontSize: "16px",
                    }
              }
            >
              Interested
            </SoftTypography>
          </SoftBox>

          <SoftBox
            sx={{
              borderTop: "1px solid #000",
              borderBottom: "1px solid #000",
              width: "175px",
              height: "45px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              p: 1,
              textAlign: "center",
              backgroundColor: tableshow === 1 ? "#3B5092" : "#fff",
            }}
            onClick={() => {
              setTableshow(1);
              setSearchParams({ show: "verify" });
            }}
          >
            <SoftTypography
              sx={
                tableshow === 1
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // color: "#1B59F8",
                      color: "#fff",
                      fontSize: "16px",
                    }
                  : {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#3B5092",
                      fontSize: "16px",
                    }
              }
            >
              Under Verification
            </SoftTypography>
          </SoftBox>

          <SoftBox
            sx={{
              border: "1px solid #000",
              // borderRadius: "5px",
              borderTopLeftRadius: "0px",
              borderBottomLeftRadius: "0px",
              width: "125px",
              height: "45px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              p: 1,
              textAlign: "center",
              backgroundColor: tableshow === 2 ? "#3B5092" : "#fff",
            }}
            onClick={() => {
              setTableshow(2);
              setSearchParams({ show: "onboarded" });
            }}
          >
            <SoftTypography
              sx={
                tableshow === 2
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // color: "#1B59F8",
                      color: "#fff",
                      fontSize: "16px",
                    }
                  : {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#3B5092",
                      fontSize: "16px",
                    }
              }
            >
              Onboarded
            </SoftTypography>
          </SoftBox>
          <SoftBox
            sx={{
              border: "1px solid #000",
              borderRadius: "5px",
              borderTopLeftRadius: "0px",
              borderBottomLeftRadius: "0px",
              width: "125px",
              height: "45px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              p: 1,
              textAlign: "center",
              backgroundColor: tableshow === 3 ? "#3B5092" : "#fff",
            }}
            onClick={() => {
              setTableshow(3);
              setSearchParams({ show: "dropout" });
            }}
          >
            <SoftTypography
              sx={
                tableshow === 3
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      // color: "#1B59F8",
                      color: "#fff",
                      fontSize: "16px",
                    }
                  : {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#3B5092",
                      fontSize: "16px",
                    }
              }
            >
              Dropout
            </SoftTypography>
          </SoftBox>
        </SoftBox>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ m: 1, minWidth: "300px", display: "flex", gap: "20px" }}>
            <SoftInput
              isClearable
              id="search-bar"
              className="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              variant="outlined"
              placeholder="Search Candidates"
            />
          </Box>

          <Box sx={{ m: 1, display: "flex", justifyContent: "space-between" }}>
            {searchParams.get("show") === "interested" && tablerow.length !== 0 && (
              <SoftBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#3B5092",
                  color: "#fff",
                  height: "33px",
                  borderRadius: "2px",
                  cursor: "pointer",
                  mr: "16px",
                  fontSize: "12px",
                  p: 1,
                }}
                onClick={() => MoveCandidatesFunc()}
              >
                {"Move to Under Verification"}
              </SoftBox>
            )}
            {searchParams.get("show") === "verify" && tablerow.length !== 0 && (
              <SoftBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#3B5092",
                  color: "#fff",
                  height: "33px",
                  borderRadius: "2px",
                  cursor: "pointer",
                  mr: "16px",
                  fontSize: "12px",
                  p: 1,
                }}
                onClick={() => MoveCandidatesFunc()}
              >
                {"Move to Onboard"}
              </SoftBox>
            )}
            {searchParams.get("show") === "onboarded" && tablerow.length !== 0 && (
              <SoftBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#3B5092",
                  color: "#fff",
                  height: "33px",
                  borderRadius: "2px",
                  cursor: "pointer",
                  mr: "16px",
                  fontSize: "12px",
                  p: 1,
                }}
                onClick={() => setStatusModal(!statusModal)}
              >
                {"Update Status"}
              </SoftBox>
            )}
            {searchParams.get("show") === "onboarded" && tablerow.length !== 0 && (
              <SoftBox
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#3B5092",
                  color: "#fff",
                  height: "33px",
                  borderRadius: "2px",
                  cursor: "pointer",
                  mr: "16px",
                  fontSize: "12px",
                  p: 1,
                }}
                onClick={() => MoveCandidatesFunc()}
              >
                {"Move to dropout"}
              </SoftBox>
            )}
            <Box sx={{ m: 0, display: "flex", justifyContent: "space-between" }}>
              {/* {tablerow.length !== 0 && tableshow === 0 && <SoftBox></SoftBox>} */}
              {/* <SoftBox>{"Move to Under Verification"}</SoftBox> */}

              <Tooltip
                key="1"
                title={tablerow.length === 0 ? "Download All" : "Download"}
                placement="top"
              >
                <SoftBox
                  sx={{
                    height: "33px",
                    backgroundColor: "#000000",
                    borderRadius: "2px",
                    cursor: "pointer",
                    mr: "16px",
                  }}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                  width="40px"
                  onClick={() => {
                    handleClick();
                  }}
                >
                  <CSVLink
                    // data={tablerow.length === 0 ? searchData : tablerow}
                    data={
                      tableshow === 0
                        ? searchData
                        : tableshow === 1
                        ? table1
                        : tableshow === 2
                        ? table2
                        : searchData
                    }
                    filename={fileName}
                    headers={
                      tableshow === 0
                        ? colHeaders.filter((ele) => ele.isExportable === true)
                        : tableshow === 1
                        ? colHeaders1.filter((ele) => ele.isExportable === true)
                        : tableshow === 2
                        ? colHeaders2.filter((ele) => ele.isExportable === true)
                        : colHeaders3.filter((ele) => ele.isExportable === true)
                    }
                  >
                    {/* <span className="login-btn3-Text">Export</span> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="46"
                      height="34"
                      viewBox="0 0 46 34"
                      fill="none"
                    >
                      <rect width="45.8992" height="33.0097" rx="5" fill="#111727" />
                      <path
                        d="M20.0547 20.1191L22.9438 23.0082L25.8328 20.1191"
                        stroke="white"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22.9531 16.5098V23.0102"
                        stroke="white"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M29.3651 20.9074C29.9931 20.4658 30.464 19.8357 30.7095 19.1084C30.955 18.381 30.9624 17.5944 30.7305 16.8626C30.4986 16.1308 30.0396 15.4919 29.4201 15.0387C28.8005 14.5854 28.0526 14.3414 27.285 14.342H26.3749C26.1577 13.4954 25.7513 12.7091 25.1862 12.0424C24.6211 11.3756 23.9121 10.8457 23.1126 10.4926C22.3131 10.1395 21.4439 9.97232 20.5705 10.0037C19.697 10.0351 18.8421 10.2643 18.07 10.6739C17.2979 11.0836 16.6288 11.663 16.1131 12.3687C15.5974 13.0743 15.2485 13.8877 15.0926 14.7477C14.9368 15.6078 14.978 16.4919 15.2133 17.3337C15.4486 18.1754 15.8718 18.9528 16.451 19.6073"
                        stroke="white"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </CSVLink>
                </SoftBox>
              </Tooltip>

              {/* <Tooltip key="1" title="Filter" placement="top">
                <SoftBox
                  sx={{
                    height: "33px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "2px",
                    cursor: "pointer",
                    mr: "16px",
                  }}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                  width="40px"
                  onClick={() => setShowFilter(true)}
                >
                  <SoftBox>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="34"
                      viewBox="0 0 39 37"
                      fill="none"
                    >
                      <rect width="38.8889" height="37" rx="2" fill="white" />
                      <path
                        d="M28.8889 10H10L17.5556 18.9344V25.1111L21.3333 27V18.9344L28.8889 10Z"
                        stroke="#A4A4A4"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SoftBox>
                </SoftBox>
              </Tooltip> */}

              {sessionStorage.getItem("cp_type") !== "Vakrangee" && (
                <Tooltip key="2" title="Bulk upload candidates" placement="top">
                  <SoftBox
                    sx={{
                      height: "33px",
                      backgroundColor: "#000000",
                      borderRadius: "2px",
                      cursor: "pointer",
                      mr: "16px",
                    }}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
                    width="40px"
                    onClick={() => setUploadModal(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <g fill="none">
                        <path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z" />
                        <path
                          fill="#fff"
                          d="M8 9v2H5v9h14v-9h-3V9h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h3Zm4.884-6.531l3.359 3.358a1 1 0 1 1-1.415 1.415L13 5.413V15a1 1 0 1 1-2 0V5.413L9.172 7.242a1 1 0 1 1-1.415-1.415l3.36-3.358a1.25 1.25 0 0 1 1.767 0Z"
                        />
                      </g>
                    </svg>
                  </SoftBox>
                </Tooltip>
              )}
            </Box>
          </Box>
        </Box>

        <Grid container>
          <SoftBox width="100%" height="auto" mt={0}>
            <SoftBox mb={3}>
              <Grid container>
                <Grid container item xs={12} lg={12}>
                  <SoftBox
                    alignItems="flex-start"
                    position="relative"
                    borderRadius="10px"
                    width="100%"
                  >
                    {tableshow === 0 && (
                      <Table
                        loading={isLoading}
                        rowSelection={rowSelection}
                        columns={colName}
                        dataSource={searchData}
                        scroll={{ x: 1600, y: 400 }}
                        pagination={{
                          // defaultPageSize: ,
                          // position: ["none", "bottomCenter"],
                          pageSizeOptions: ["10", "20", "50", "100", "500"],
                          // total: paginationState.dataSize,
                          showSizeChanger: true,
                          // onShowSizeChange: handlePageSizeChange,
                          // current: paginationState.page,
                          // onChange: (page, pageSize) =>
                          //   setPaginationState({ ...paginationState, page: page }),
                          showTotal: (total, range) => (
                            <span>
                              Showing{" "}
                              <strong>
                                {range[0]} - {range[1]}
                              </strong>{" "}
                              results of {total}
                            </span>
                          ),
                        }}
                      />
                    )}

                    {tableshow === 1 && (
                      <Table
                        loading={isLoading}
                        columns={colName1}
                        rowSelection={rowSelection}
                        dataSource={table1?.filter((ele) => {
                          return name?.toLocaleLowerCase() === ""
                            ? ele
                            : ele.candidate
                                ?.toLocaleLowerCase()
                                .includes(name.toLocaleLowerCase()) ||
                              name.toLocaleLowerCase() === ""
                            ? ele
                            : String(ele.mobile)
                                .toLocaleLowerCase()
                                .includes(name.toLocaleLowerCase());
                        })}
                        pagination={{
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "20", "50", "100", "500"],
                          showTotal: (total, range) => (
                            <span>
                              Showing{" "}
                              <strong>
                                {range[0]} - {range[1]}
                              </strong>{" "}
                              results of {total}
                            </span>
                          ),
                        }}
                        scroll={{ x: 1800, y: 400 }}
                      />
                    )}

                    {tableshow === 2 && (
                      <Table
                        loading={isLoading}
                        columns={colName2}
                        rowSelection={rowSelection}
                        dataSource={table2?.filter((ele) => {
                          return name?.toLocaleLowerCase() === ""
                            ? ele
                            : ele.candidate
                                ?.toLocaleLowerCase()
                                .includes(name.toLocaleLowerCase()) ||
                              name.toLocaleLowerCase() === ""
                            ? ele
                            : String(ele.mobile)
                                .toLocaleLowerCase()
                                .includes(name.toLocaleLowerCase());
                        })}
                        pagination={{
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "20", "50", "100", "500"],
                          showTotal: (total, range) => (
                            <span>
                              Showing{" "}
                              <strong>
                                {range[0]} - {range[1]}
                              </strong>{" "}
                              results of {total}
                            </span>
                          ),
                        }}
                        scroll={{ x: 2000, y: 400 }}
                      />
                    )}
                    {tableshow === 3 && (
                      <Table
                        loading={isLoading}
                        rowSelection={rowSelection}
                        columns={colName3}
                        dataSource={searchData}
                        scroll={{ x: 1400, y: 400 }}
                        pagination={{
                          // defaultPageSize: ,
                          // position: ["none", "bottomCenter"],
                          pageSizeOptions: ["10", "20", "50", "100", "500"],
                          showSizeChanger: true,
                          showTotal: (total, range) => (
                            <span>
                              Showing{" "}
                              <strong>
                                {range[0]} - {range[1]}
                              </strong>{" "}
                              results of {total}
                            </span>
                          ),
                        }}
                      />
                    )}
                  </SoftBox>
                </Grid>
              </Grid>
            </SoftBox>
          </SoftBox>
        </Grid>
      </DashboardLayout>

      <SoftSnackbar
        color="success"
        icon="check"
        title="Link copied successfully"
        content={copiedLink}
        // dateTime="11 mins ago"
        open={showSnackbar}
        autoHideDuration={4000}
        close={toggleSnackbar}
      />

      {/* Modal Status */}
      <Modal
        show={statusModal}
        onHide={() => {
          setStatusModal(false);
        }}
        centered
      >
        <Modal.Body>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV"></p>

              <IconButton onClick={() => setStatusModal(false)}>
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                // justifyContent: "space-between",
                gap: 1,
                // alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid grey",
                    fontSize: "15px",
                    borderRadius: "8px",
                    p: 1,
                    color: statusType === 0 ? "#fff" : "#000",
                    width: "150px",
                    cursor: "pointer",
                    background: statusType === 0 ? "#3B5092" : "#FFF",
                  }}
                  onClick={() => setStatusType(0)}
                >
                  {"Attendance Status"}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid grey",
                    fontSize: "15px",
                    borderRadius: "8px",
                    p: 1,
                    color: statusType === 1 ? "#fff" : "#000",
                    width: "150px",
                    cursor: "pointer",
                    background: statusType === 1 ? "#3B5092" : "#FFF",
                  }}
                  onClick={() => setStatusType(1)}
                >
                  {"Test Status"}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid grey",
                    fontSize: "15px",
                    borderRadius: "8px",
                    p: 1,
                    color: statusType === 2 ? "#fff" : "#000",
                    width: "150px",
                    cursor: "pointer",
                    background: statusType === 2 ? "#3B5092" : "#FFF",
                  }}
                  onClick={() => setStatusType(2)}
                >
                  {"OJT Status"}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid grey",
                    fontSize: "15px",
                    borderRadius: "8px",
                    p: 1,
                    color: statusType === 3 ? "#fff" : "#000",
                    width: "150px",
                    cursor: "pointer",
                    background: statusType === 3 ? "#3B5092" : "#FFF",
                  }}
                  onClick={() => setStatusType(3)}
                >
                  {"Placement Status"}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid grey",
                    fontSize: "15px",
                    borderRadius: "8px",
                    p: 1,
                    color: statusType === 4 ? "#fff" : "#000",
                    width: "150px",
                    cursor: "pointer",
                    background: statusType === 4 ? "#3B5092" : "#FFF",
                  }}
                  onClick={() => setStatusType(4)}
                >
                  {"Self Employee Status"}
                </Box>
              </Box>
              <Box sx={{ borderLeft: "1px solid grey", height: "300px" }}></Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "space-between",
                  // gap: 2,
                }}
              >
                {statusType === 0 ? (
                  <Box
                    sx={{
                      fontSize: "15px",
                    }}
                  >
                    {attendenceStatus.map((ele, id) => (
                      <Box key={id}>
                        <input
                          type="radio"
                          id={ele.label}
                          name="attendence_status"
                          value={ele.value}
                          onChange={(e) => setStatusValue(e.target.value)}
                        />
                        <label
                          htmlFor={ele.label}
                          style={{ marginLeft: 1, cursor: "pointer", textAlign: "center" }}
                        >
                          {ele.label}
                        </label>
                      </Box>
                    ))}
                  </Box>
                ) : statusType === 1 ? (
                  <Box
                    sx={{
                      fontSize: "15px",
                    }}
                  >
                    {testStatus.map((ele, id) => (
                      <Box key={id}>
                        <input
                          type="radio"
                          id={ele.label}
                          name="test_status"
                          value={ele.value}
                          onChange={(e) => setStatusValue(e.target.value)}
                        />
                        <label
                          htmlFor={ele.label}
                          style={{ marginLeft: 1, cursor: "pointer", textAlign: "center" }}
                        >
                          {ele.label}
                        </label>
                      </Box>
                    ))}
                  </Box>
                ) : statusType === 2 ? (
                  <Box
                    sx={{
                      fontSize: "15px",
                    }}
                  >
                    {ojtStatus.map((ele, id) => (
                      <Box key={id}>
                        <input
                          type="radio"
                          id={ele.label}
                          name="ojt_status"
                          value={ele.value}
                          onChange={(e) => setStatusValue(e.target.value)}
                        />
                        <label
                          htmlFor={ele.label}
                          style={{ marginLeft: 1, cursor: "pointer", textAlign: "center" }}
                        >
                          {ele.label}
                        </label>
                      </Box>
                    ))}
                  </Box>
                ) : statusType === 3 ? (
                  <Box
                    sx={{
                      fontSize: "15px",
                    }}
                  >
                    {placementStatus.map((ele, id) => (
                      <Box key={id}>
                        <input
                          type="radio"
                          id={ele.label}
                          name="placement_status"
                          value={ele.value}
                          onChange={(e) => setStatusValue(e.target.value)}
                        />
                        <label
                          htmlFor={ele.label}
                          style={{ marginLeft: 1, cursor: "pointer", textAlign: "center" }}
                        >
                          {ele.label}
                        </label>
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      fontSize: "15px",
                    }}
                  >
                    {selfEmpStatus.map((ele, id) => (
                      <Box key={id}>
                        <input
                          type="radio"
                          id={ele.label}
                          name="self_employed"
                          value={ele.value}
                          onChange={(e) => setStatusValue(e.target.value)}
                        />
                        <label
                          htmlFor={ele.label}
                          style={{ marginLeft: 1, cursor: "pointer", textAlign: "center" }}
                        >
                          {ele.label}
                        </label>
                      </Box>
                    ))}
                  </Box>
                )}
                <Box width="100%" pl={0} mt={2} display="flex" justifyContent="center" gap={2}>
                  <Box
                    // pl={2}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    border={0.2}
                    borderColor="#8080804f"
                    sx={{
                      height: "40px",
                      backgroundColor: "#FFFF",
                      // borderColor: "red",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    width={{ lg: "100px", sm: "100%", xs: "50%" }}
                    onClick={() => (setStatusModal(false), setStatusType(0), setStatusValue(""))}
                  >
                    <Box
                      sx={{
                        color: "#3B5092",
                        fontSize: "15px",
                        fontWeight: "medium",
                        lineHeight: "19px",
                      }}
                    >
                      Cancel
                    </Box>
                  </Box>
                  <Box
                    type="submit"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      height: "40px",
                      backgroundColor: "#3B5092",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    // p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
                    width={{ lg: "100px", sm: "100%", xs: "50%" }}
                    onClick={() => UpdateStatusFunc(statusType)}
                  >
                    <Box
                      alignItems="center"
                      sx={{
                        color: "#fff",
                        fontSize: "15px",
                        fontWeight: "medium",
                        lineHeight: "19px",
                      }}
                    >
                      Update
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal.Body>
      </Modal>
      {/* Modal Status */}
      {/* Modal to View Docs */}
      <Modal
        show={viewDocsModal}
        onHide={() => {
          setViewDocsModal(false);
          // setUploadOption(false);
          // setShowSnackbar(false);
        }}
        centered
      >
        <Modal.Body>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV"></p>

              <IconButton onClick={() => setViewDocsModal(false)}>
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="doc-table"
            >
              <table>
                <tr>
                  <th className="doc-head">Document Type</th>
                  <th className="doc-head">View</th>
                </tr>

                {allDocs.map((ele, id) => (
                  <tr key={id}>
                    <td>{ele.name}</td>
                    <td>
                      <a href={ele.value} rel="noreferrer" target="_blank">
                        {"Click"}
                      </a>
                    </td>
                  </tr>
                ))}
              </table>
            </Box>
          </Box>
        </Modal.Body>
      </Modal>
      {/* Modal to View Docs */}
      {/* modal for export */}
      <Modal
        show={uploadModal}
        onHide={() => {
          setUploadModal(false);
          setUploadOption(false);
          setCSVFile1("");
          setRefFile1("");
          setStageName("");
          // setShowSnackbar(false);
        }}
        centered
      >
        <Modal.Body>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV">Upload Candidate</p>

              <IconButton
                onClick={() => (
                  setUploadModal(false), setCSVFile1(""), setRefFile1(""), setStageName("")
                )}
              >
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <SoftBox m={2}>
              <SoftBox
                my={1}
                sx={{
                  borderRadius: 1,
                  backgroundColor: "#F7F5FE",
                  border: "1px dashed #384EB74D",
                  height: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "10px",
                  cursor: "pointer",
                }}
                onClick={() => handleClickFile()}
              >
                <img src={upload} alt="" />
                <SoftBox sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
                  <SoftTypography sx={{ fontSize: "16px", fontWeight: "700", color: "#000" }}>
                    Drag & drop files or
                  </SoftTypography>
                  <SoftTypography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#3B5092",
                      textDecoration: "underline",
                    }}
                  >
                    Browse
                  </SoftTypography>
                </SoftBox>
                <SoftTypography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: refFile1 == "" ? "#676767" : "#3B5092",
                  }}
                >
                  {refFile1 == "" ? "Supported formats: xlsx (Excel)" : refFile1.name}
                </SoftTypography>
                <input
                  // className="form-control"
                  type="file"
                  accept=".xlsx"
                  id="datasource"
                  name="datasource"
                  ref={hiddenFileInput}
                  style={{ display: "none" }}
                  onChange={(e) => {
                    // const file = e.target.files[0],
                    console.log("refFile ", e.target.files[0]), setCSVFile1(e.target.files[0]);
                    setRefFile1(e.target.files[0]);
                  }}
                />
              </SoftBox>
              {/* <Select placeholder="Select Stage" options={stageoptions} onChange={(e)=>setStageSelect(e)}></Select> */}

              <SoftBox display="flex" justifyContent="center">
                <Link to="/Data-Upload-Template.xlsx" target="_blank" download>
                  <SoftBox
                    sx={{
                      border: "1px solid #8080803b",
                      borderRadius: 1,
                      p: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* <CloudDownloadIcon /> */}
                    <svg
                      width="21"
                      height="17"
                      viewBox="0 0 21 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.5 6V12M10.5 12L8.5 10M10.5 12L12.5 10M6.9 15.5C3.91766 15.5 1.5 13.1044 1.5 10.1493C1.5 7.70008 3.3 5.4375 6 5C6.84694 2.98637 8.85139 1.5 11.1893 1.5C14.184 1.5 16.6317 3.82251 16.8 6.75C18.3893 7.44488 19.5 9.15031 19.5 10.9969C19.5 13.4839 17.4853 15.5 15 15.5L6.9 15.5Z"
                        stroke="#3B5092"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    <SoftTypography sx={{ color: "#072AC8", fontSize: "14px", pl: 1 }}>
                      Download Template
                    </SoftTypography>
                  </SoftBox>
                </Link>
              </SoftBox>
              {refFile1 !== "" && (
                <SoftBox display="flex" justifyContent="center" mt={1}>
                  <Select
                    isClearable
                    // value={jobList?.filter((ele) => courseId === ele.value)}
                    placeholder="Select Stage"
                    options={stageoptions}
                    onChange={(e) => setStageSelect(e)}
                    styles={stylesDD}
                  />
                </SoftBox>
              )}
              <SoftBox width="100%" pl={2} mt={3} display="flex" justifyContent="center" gap={2}>
                <SoftBox
                  // pl={2}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  border={0.2}
                  borderColor="#8080804f"
                  sx={{
                    height: "40px",
                    backgroundColor: "#FFFF",
                    // borderColor: "red",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  width={{ lg: "150px", sm: "100%", xs: "50%" }}
                  onClick={() => (
                    setCSVFile1(""), setRefFile1(""), setUploadModal(false), setStageName("")
                  )}
                >
                  <SoftTypography
                    sx={{
                      color: "#3B5092",
                      fontSize: "15px",
                      fontWeight: "medium",
                      lineHeight: "19px",
                    }}
                  >
                    Cancel
                  </SoftTypography>
                </SoftBox>
                <SoftBox
                  type="submit"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    height: "40px",
                    backgroundColor: "#3B5092",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  // p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
                  width={{ lg: "150px", sm: "100%", xs: "50%" }}
                  onClick={() =>
                    // ds === "" || CSVFile === ""
                    //   ? () =>
                    //       Swal.fire({
                    //         icon: "info",
                    //         title: "Please select datasource",
                    //         //text: err?.data["User Message"],
                    //         showConfirmButton: false,
                    //         timer: 3000,
                    //       })
                    //   :
                    HandleBulkUpload()
                  }
                >
                  <SoftTypography
                    alignItems="center"
                    sx={{
                      color: "#fff",
                      fontSize: "15px",
                      fontWeight: "medium",
                      lineHeight: "19px",
                    }}
                  >
                    Upload
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </Box>
        </Modal.Body>
      </Modal>
      {/* modal for export */}

      <Modal
        show={resumeModal}
        onHide={() => {
          setResumeModal(false);
        }}
        centered
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <SoftBox sx={{ m: 0 }}>
          {console.log("rowdata for resume:", rowData)}
          <Modal.Body>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <p className="HeaderCSV">Upload Resume </p>

              <button className="CloseBtn" onClick={() => setResumeModal(false)}>
                {/* <span>
                  <CloseIcon fontSize="small" />
                </span> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                // justifyContent: "space-between",
                gap: "20px",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              <input
                className="form-control"
                type="file"
                accept=".pdf, .doc, .docx, .png, .jpg, .jpeg"
                id="datasource"
                name="datasource"
                onChange={(e) => {
                  // const file = e.target.files[0],
                  console.log("resumefile ", e.target.files[0]),
                    setResumeFile(e ? e.target.files[0] : "");
                }}
              />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "40px" }}>
              <button
                className="login-btn3"
                onClick={() => {
                  ResumeUploadFunc(rowData);
                }}
              >
                <span className="login-btn3-Text">Save</span>
              </button>
              <button className="login-btn4" onClick={() => setResumeModal(false)}>
                <span className="login-btn4-Text">Cancel</span>
              </button>
            </Box>
          </Modal.Body>
        </SoftBox>
      </Modal>

      {/* modal for instructions */}
      <Modal
        show={instructionModal}
        onHide={() => {
          setInstructionModal(false);
          setUploadModal(true);
        }}
        size="xl"
        centered
      >
        <Modal.Body>
          <SoftBox width="100%" display="flex" justifyContent="flex-end" alignItems="center">
            <IconButton
              onClick={() => {
                setInstructionModal(false);
                setUploadModal(true);
              }}
            >
              {/* <CloseIcon size="small" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9.16992 14.8299L14.8299 9.16992"
                  stroke="#3A3A3A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.8299 14.8299L9.16992 9.16992"
                  stroke="#3A3A3A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                  stroke="#3A3A3A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </IconButton>
          </SoftBox>

          <SoftBox
            sx={{
              border: "1px solid #6c6c6c",
              borderRadius: "10px",
              padding: "10px",
              marginBottom: "10px",
            }}
          >
            <SoftTypography fontSize="20px" fontWeight="medium" marginTop="12px">
              Guidelines:
            </SoftTypography>
            <SoftTypography fontSize="16px">
              While uploading the file (only excel files accepted), you have to make sure that the
              following fields with exact headers are present. The system will accept files only if
              the following headers are present. Even if there is no data in any of the headers, the
              data will still be accepted (try to put as much data as possible). Any data without
              mobile number (in 10 digits) will be rejected.
            </SoftTypography>
            <br />

            <SoftTypography fontStyle="12px" fontSize="16px">
              <ul>
                <li>First Name</li>
                <li>Date of Birth (DD-MM-YYYY)</li>
                <li>Mobile Number</li>
                <li>District</li>
                <li>State</li>
                <li>Highest Education</li>
              </ul>
            </SoftTypography>
            <br />
          </SoftBox>
          <SoftBox sx={{ marginTop: "10px" }}>
            <SoftTypography fontSize="16px" marginBottom="16px">
              The following section explains how all the data should be entered.
            </SoftTypography>
            <Table columns={colGuidelines} dataSource={GuideData} pagination={false} mb={2} />
          </SoftBox>
        </Modal.Body>
      </Modal>
      {/* modal for instructions */}

      {/* modal for export */}
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
        centered
      >
        <Modal.Body>
          <SoftBox sx={{ m: 0 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <p className="HeaderCSV">Select columns to export</p>

              <button className="CloseBtn" onClick={() => setShow(false)}>
                {/* <span>
                  <CloseIcon fontSize="small" />
                </span> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </Box>

            {colHeaders.map((ele, index) => (
              <>
                <ul className="UlCSV" key={index}>
                  <input
                    type="checkbox"
                    checked={ele.isExportable}
                    onChange={(event) =>
                      handleFormChange12(event, index, colHeaders, setColHeaders)
                    }
                  />
                  <span className="ListCSV">&nbsp;{ele.label}</span>
                </ul>
              </>
            ))}

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <button className="login-btn4" onClick={() => setShow(false)}>
                <span className="login-btn4-Text">Cancel</span>
              </button>

              <button className="login-btn3">
                {/* <SoftTypography display="flex" justifyContent="center" sx={{ color: "#fff", fontSize: "15px", fontWeight: "medium", lineHeight: "19px" }}>
                      Download
                    </SoftTypography> */}
                <CSVLink
                  data={tablerow.length === 0 ? searchData : tablerow}
                  //data={selectedCSVData}
                  filename={fileName}
                  headers={colHeaders.filter((ele) => ele.isExportable === true)}
                >
                  <span className="login-btn3-Text">Export</span>
                </CSVLink>
              </button>
            </Box>
          </SoftBox>
        </Modal.Body>
      </Modal>
      {/* modal for export */}

      {/* modal for uploading */}
      <Modal
        show={downloadingModal}
        onHide={() => {
          setDownloadingModal(false);
        }}
        centered
        size="sm"
        closeButton
        contentClassName="modal-height"
      >
        <Modal.Body>
          <SoftBox display="flex" justifyContent="center" alignItems="center">
            <SoftBox display="flex" flexDirection="column" gap={3}>
              <SoftTypography sx={{ fontSize: "14px", fontWeight: 600 }}>
                Downloading.....
              </SoftTypography>
              <SoftTypography sx={{ fontSize: "14px", fontWeight: 400 }}>
                Please wait as we are downloading the file
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </Modal.Body>
      </Modal>
      {/* modal for uploading */}

      {/* Modal to View Docs */}
      <Modal
        show={viewAttd}
        onHide={() => {
          setViewAttd(false);
          // setUploadOption(false);
          // setShowSnackbar(false);
        }}
        centered
      >
        <Modal.Body>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV"></p>

              <IconButton onClick={() => setViewAttd(false)}>
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              // className="doc-table"
            >
              {/* <table>
                <tr>
                  <th className="doc-head">Date</th>
                  <th className="doc-head">Clock In</th>
                  <th className="doc-head">Clock Out</th>
                </tr>

                {allDocs.map((ele, id) => (
                  <tr key={id}>
                    <td>{ele.name}</td>
                    <td>
                      <a href={ele.value} rel="noreferrer" target="_blank">
                        {"Click"}
                      </a>
                    </td>
                  </tr>
                ))}
              </table> */}
              <AttdTable columns={attdColumn} dataSource={attdTable} exportable />
            </Box>
          </Box>
        </Modal.Body>
      </Modal>
      {/* Modal to View Docs */}

      {/* Upload Media Modal */}
      <Modal
        show={uploadMedia}
        onHide={() => {
          setUploadMedia(false);
          // setUploadOption(false);
          // setShowSnackbar(false);
        }}
        centered
      >
        <Modal.Body>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: -1.5,
              }}
            >
              <p className="HeaderCSV">Upload Feedback</p>

              <IconButton onClick={() => setUploadMedia(false)}>
                {/* <CloseIcon fontSize="small" /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                    stroke="#3A3A3A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Box>
            <SoftBox m={2}>
              {/* <SoftBox
                my={1}
                sx={{
                  borderRadius: 1,
                  backgroundColor: "#F7F5FE",
                  border: "1px dashed #384EB74D",
                  height: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "10px",
                  cursor: "pointer",
                }}
                onClick={() => handleClickFile()}
              >
                <img src={upload} alt="" />
                <SoftBox sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
                  <SoftTypography sx={{ fontSize: "16px", fontWeight: "700", color: "#000" }}>
                    Drag & drop files or
                  </SoftTypography>
                  <SoftTypography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#3B5092",
                      textDecoration: "underline",
                    }}
                  >
                    Browse
                  </SoftTypography>
                </SoftBox>
                <SoftTypography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: refFile2 == "" ? "#676767" : "#3B5092",
                    height: "100px",
                  }}
                >
                  {refFile2 == ""
                    ? "Supported formats:  .mp4"
                    : // <ol>
                      //   {refFile2.map((itm, id) => (
                      //     <li key={id}>
                      //       {itm.name} - {itm.type}
                      //     </li>
                      //   ))}
                      // </ol>
                      refFile2.name}
                </SoftTypography>
                <input
                  // className="form-control"
                  type="file"
                  accept="image/*,video/*"
                  id="media"
                  name="media"
                  ref={hiddenFileInput}
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    // const files = Array.from(e.target.files);
                    // setRefFile2((prevFiles) => [...prevFiles, ...files]);
                    // setCSVFile2(e.target.files);
                    // console.log("refFile2 ", e.target.files), setCSVFile2(e.target.files);
                    setRefFile2(file);
                  }}
                  // multiple
                />
              </SoftBox>
              <p
                // className="HeaderCSV"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#000",
                  marginTop: "12px",
                }}
              >
                or
              </p> */}
              <SoftBox>
                <SoftInput
                  type="text"
                  placeholder="Drive link"
                  name="drive_link"
                  id="drive_link"
                  onChange={(e) => setCSVFile2(e.target.value)}
                  // value={batchForm.values.batch_name}
                />
              </SoftBox>

              <SoftBox sx={{ display: "flex", alignItems: "center", gap: 3, mt: 2 }}>
                <SoftTypography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "400",
                    // color: refFile2 == "" ? "#676767" : "#3B5092",
                    // height: "100px",
                  }}
                >
                  Feedback Stage :
                </SoftTypography>
                <SoftBox
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 5,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      // justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="radio"
                      id="Pre"
                      name="feedback"
                      value="pre-session"
                      defaultChecked
                      onChange={(e) => setStageName(e.target.value)}
                    />
                    <label
                      htmlFor="Pre"
                      style={{
                        marginLeft: 1,
                        cursor: "pointer",
                        textAlign: "center",
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                    >
                      {"Pre-Session"}
                    </label>
                  </div>
                  {/* <label>Pre</label> */}
                  <div
                    style={{
                      display: "flex",
                      // justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="radio"
                      id="Post"
                      name="feedback"
                      value="post-session"
                      onChange={(e) => setStageName(e.target.value)}
                    />
                    <label
                      htmlFor="Post"
                      style={{
                        marginLeft: 1,
                        cursor: "pointer",
                        textAlign: "center",
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                    >
                      {"Post-Session"}
                    </label>
                  </div>
                </SoftBox>
              </SoftBox>

              <SoftBox width="100%" pl={2} mt={3} display="flex" justifyContent="center" gap={2}>
                <SoftBox
                  // pl={2}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  border={0.2}
                  borderColor="#8080804f"
                  sx={{
                    height: "40px",
                    backgroundColor: "#FFFF",
                    // borderColor: "red",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  width={{ lg: "150px", sm: "100%", xs: "50%" }}
                  onClick={() => (setCSVFile2(""), setRefFile2(""), setUploadMedia(false))}
                >
                  <SoftTypography
                    sx={{
                      color: "#3B5092",
                      fontSize: "15px",
                      fontWeight: "medium",
                      lineHeight: "19px",
                    }}
                  >
                    Cancel
                  </SoftTypography>
                </SoftBox>
                <SoftBox
                  type="submit"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    height: "40px",
                    backgroundColor: "#3B5092",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  // p={{ lg: "13px 84px", sm: "13px 100px", xs: "13px 140px" }}
                  width={{ lg: "150px", sm: "100%", xs: "50%" }}
                  onClick={() => HandleUploadMediaLoop()}
                >
                  <SoftTypography
                    alignItems="center"
                    sx={{
                      color: "#fff",
                      fontSize: "15px",
                      fontWeight: "medium",
                      lineHeight: "19px",
                    }}
                  >
                    Upload
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </Box>
        </Modal.Body>
      </Modal>
      {/* Upload Media Modal */}

      <Index
        open={showFilter}
        setOpen={setShowFilter}
        statefilter={statefilter}
        setStatefilter={setStatefilter}
        districtfilter={districtfilter}
        setDistrictfilter={setDistrictfilter}
        datefilter={datefilter}
        setDatefilter={setDatefilter}
        resetfunc={resetfunc}
        jffilter={jffilter}
        setJffilter={setJffilter}
        table={table}
        educationfilter={educationfilter}
        setEducationfilter={setEducationfilter}
        rolefilter={rolefilter}
        setRolefilter={setRolefilter}
        degreefilter={degreefilter}
        setDegreefilter={setDegreefilter}
        boardingfilter={boardingfilter}
        setBoardingfilter={setBoardingfilter}
        setFunc={setFunc}
        fetchFilteredCandidates={fetchFilteredCandidates}
      />

      <SideDrawer
        openModal={openModal}
        setOpenModal={setOpenModal}
        veridetails={veridetails}
        setVeridetails={setVeridetails}
        timelineLoading={timelineLoading}
        setTimeLineLoading={setTimeLineLoading}
        time={time}
        setTime={setTime}
        candData={candData}
        setCandData={setCandData}
      />
    </>
  );
};

export default StudentList;
